import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2210e02a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "filter-distribution-group-wrapper",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title header-title mt-3" }, "基本セグメント")
], -1))
const _hoisted_3 = { class: "input-field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "性別設定", -1))
const _hoisted_5 = { class: "flex flex-wrap gap-5 mt-2" }
const _hoisted_6 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender-1",
  class: "ml-2"
}, "男性", -1))
const _hoisted_8 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender-2",
  class: "ml-2"
}, "女性", -1))
const _hoisted_10 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender-3",
  class: "ml-2"
}, "その他", -1))
const _hoisted_12 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "gender-4",
  class: "ml-2"
}, "すべて", -1))
const _hoisted_14 = { class: "input-field mt-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "年齢設定", -1))
const _hoisted_16 = { class: "field-radiobutton md:mr-1" }
const _hoisted_17 = { class: "col-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-age-template",
  class: "mx-2 label-input"
}, "年代タグ :", -1))
const _hoisted_19 = { class: "grid select-input ml-0" }
const _hoisted_20 = { class: "field-radiobutton md:mr-1 mt-3" }
const _hoisted_21 = { class: "col-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-age-range",
  class: "ml-2 label-input"
}, "特定の年齢 :", -1))
const _hoisted_23 = { class: "input-field mt-5" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "ステータス設定", -1))
const _hoisted_25 = { class: "field-radiobutton md:mr-1 mb-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label-input ml-2" }, "来店ステータス:")
], -1))
const _hoisted_27 = { class: "grid select-input ml-0" }
const _hoisted_28 = { class: "field-radiobutton md:mr-1 mb-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label-input ml-2" }, "顧客ステータス:")
], -1))
const _hoisted_30 = { class: "grid select-input ml-0" }
const _hoisted_31 = { class: "input-field mt-5" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "期間設定", -1))
const _hoisted_33 = { class: "field-radiobutton md:mr-1 mt-2" }
const _hoisted_34 = { class: "col-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-visited-time-template",
  class: "ml-2 label-input"
}, "最終来店日設定:", -1))
const _hoisted_36 = { class: "grid select-input ml-0" }
const _hoisted_37 = { class: "field-radiobutton md:mr-1 mt-3" }
const _hoisted_38 = { class: "col-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-visited-time-range",
  class: "ml-2 label-input"
}, "希望期間設定:", -1))
const _hoisted_40 = { class: "mr-5" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-input" }, "開始日", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label-input" }, "終了日", -1))
const _hoisted_43 = { class: "input-field mt-5" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "来店履歴設定", -1))
const _hoisted_45 = { class: "field-radiobutton md:mr-1 mt-2" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label-input ml-2" }, "期間選択:")
], -1))
const _hoisted_47 = { class: "flex flex-wrap gap-5 mt-2" }
const _hoisted_48 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-all-time",
  class: "ml-2"
}, "全期間", -1))
const _hoisted_50 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-current-month",
  class: "ml-2"
}, "当月内", -1))
const _hoisted_52 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-three-months",
  class: "ml-2"
}, "3ヶ月以内", -1))
const _hoisted_54 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-half-year",
  class: "ml-2"
}, "半年以内", -1))
const _hoisted_56 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-one-year",
  class: "ml-2"
}, "1年以内", -1))
const _hoisted_58 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-history-visit-custom-period",
  class: "ml-2"
}, "任意期間", -1))
const _hoisted_60 = {
  key: 0,
  class: "field-radiobutton md:mr-1 mt-3"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_62 = { class: "grid ml-0" }
const _hoisted_63 = {
  key: 0,
  class: "col-12 mb-2"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm" }, "開始日は終了日より前の日付を設定してください")
], -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "col-6" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "開始日", -1))
const _hoisted_68 = { class: "col-6" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "終了日", -1))
const _hoisted_70 = { class: "field-radiobutton md:mr-1 mt-3" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_72 = { class: "grid select-input ml-0" }
const _hoisted_73 = { class: "col-12 mb-2" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium mb-1" }, "総来店回数:", -1))
const _hoisted_75 = { class: "flex align-items-center gap-2" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "〜", -1))
const _hoisted_77 = { class: "col-12" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium mb-1" }, "月平均来店回数:", -1))
const _hoisted_79 = { class: "flex align-items-center gap-2" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "〜", -1))
const _hoisted_81 = { class: "input-field mt-5" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "利用金額設定", -1))
const _hoisted_83 = { class: "field-radiobutton md:mr-1 mt-2" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label-input ml-2" }, "平均単価:")
], -1))
const _hoisted_85 = { class: "grid select-input ml-0" }
const _hoisted_86 = { class: "col-12 mb-3" }
const _hoisted_87 = {
  key: 0,
  class: "error-message mb-2"
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm" }, "半角数字以外の入力はできません", -1))
const _hoisted_90 = [
  _hoisted_88,
  _hoisted_89
]
const _hoisted_91 = {
  key: 1,
  class: "error-message mb-2"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_93 = { class: "text-red-500 text-sm" }
const _hoisted_94 = { class: "amount-range-container mt-2" }
const _hoisted_95 = { class: "amount-range-item" }
const _hoisted_96 = { class: "amount-checkbox-group left" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "下限なし", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-4" }, "〜", -1))
const _hoisted_99 = { class: "amount-range-item" }
const _hoisted_100 = { class: "amount-checkbox-group right" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "上限なし", -1))
const _hoisted_102 = { class: "field-radiobutton md:mr-1 mt-2" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "label-input ml-2" }, "期間選択:")
], -1))
const _hoisted_104 = { class: "flex flex-wrap gap-5 mt-2" }
const _hoisted_105 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-all-time",
  class: "ml-2"
}, "全期間", -1))
const _hoisted_107 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-current-month",
  class: "ml-2"
}, "当月内", -1))
const _hoisted_109 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-three-months",
  class: "ml-2"
}, "3ヶ月以内", -1))
const _hoisted_111 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-half-year",
  class: "ml-2"
}, "半年以内", -1))
const _hoisted_113 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-one-year",
  class: "ml-2"
}, "1年以内", -1))
const _hoisted_115 = { class: "flex align-items-center radio-wrapper-custom mr-5" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filter-amount-custom-period",
  class: "ml-2"
}, "任意期間", -1))
const _hoisted_117 = {
  key: 0,
  class: "field-radiobutton md:mr-1 mt-3"
}
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_119 = { class: "grid ml-0" }
const _hoisted_120 = {
  key: 0,
  class: "col-12 mb-2"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-message" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm" }, "開始日は終了日より前の日付を設定してください")
], -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = { class: "col-6" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "開始日", -1))
const _hoisted_125 = { class: "col-6" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "終了日", -1))
const _hoisted_127 = { class: "field-radiobutton md:mr-1 mt-3" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))
const _hoisted_129 = { class: "grid select-input ml-0" }
const _hoisted_130 = { class: "col-12 mb-3" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium mb-3" }, "総利用金額:", -1))
const _hoisted_132 = {
  key: 0,
  class: "error-message mb-2"
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm" }, "半角数字以外の入力はできません", -1))
const _hoisted_135 = [
  _hoisted_133,
  _hoisted_134
]
const _hoisted_136 = {
  key: 1,
  class: "error-message mb-2"
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_138 = { class: "text-red-500 text-sm" }
const _hoisted_139 = { class: "amount-range-container mt-2" }
const _hoisted_140 = { class: "amount-range-item" }
const _hoisted_141 = { class: "amount-checkbox-group left" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "下限なし", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-4" }, "〜", -1))
const _hoisted_144 = { class: "amount-range-item" }
const _hoisted_145 = { class: "amount-checkbox-group right" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "上限なし", -1))
const _hoisted_147 = { class: "col-12" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-medium mb-3" }, "月平均利用金額:", -1))
const _hoisted_149 = {
  key: 0,
  class: "error-message mb-2"
}
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 text-sm" }, "半角数字以外の入力はできません", -1))
const _hoisted_152 = [
  _hoisted_150,
  _hoisted_151
]
const _hoisted_153 = {
  key: 1,
  class: "error-message mb-2"
}
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle text-red-500 mr-2" }, null, -1))
const _hoisted_155 = { class: "text-red-500 text-sm" }
const _hoisted_156 = { class: "amount-range-container mt-2" }
const _hoisted_157 = { class: "amount-range-item" }
const _hoisted_158 = { class: "amount-checkbox-group left" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "下限なし", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-4" }, "〜", -1))
const _hoisted_161 = { class: "amount-range-item" }
const _hoisted_162 = { class: "amount-checkbox-group right" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm" }, "上限なし", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "title header-title mt-5" }, "タグ選択セグメント", -1))
const _hoisted_165 = [
  _hoisted_164
]
const _hoisted_166 = {
  key: 0,
  class: "card-overlay"
}
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner" }, null, -1))
const _hoisted_168 = [
  _hoisted_167
]
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "タグ選定設定", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold ml-5" }, "※複数選択可能", -1))
const _hoisted_171 = [
  _hoisted_169,
  _hoisted_170
]
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label-input font-bold" }, "手動タグ", -1))
const _hoisted_173 = [
  _hoisted_172
]
const _hoisted_174 = {
  key: 4,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_175 = {
  key: 0,
  class: "grid justify-content-end"
}
const _hoisted_176 = {
  key: 1,
  class: "grid mt-5 justify-content-center"
}
const _hoisted_177 = {
  key: 0,
  class: "pi pi-spin pi-spinner mr-2"
}
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_179 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_181 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "centered-text" }, "選定ユーザー数", -1))
const _hoisted_183 = {
  key: 0,
  class: "text-red centered-text font-bold mt-3"
}
const _hoisted_184 = {
  key: 1,
  class: "text-pink centered-text font-bold mt-3"
}
const _hoisted_185 = {
  key: 2,
  class: "text-orange centered-text font-bold mt-3"
}
const _hoisted_186 = { key: 3 }
const _hoisted_187 = { class: "result-part mt-2" }
const _hoisted_188 = { class: "filter-number" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "ユーザー", -1))
const _hoisted_190 = { key: 4 }
const _hoisted_191 = { class: "result-part mt-2" }
const _hoisted_192 = { class: "filter-number" }
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "ユーザー", -1))
const _hoisted_194 = { key: 5 }
const _hoisted_195 = { class: "result-part mt-2" }
const _hoisted_196 = { class: "filter-number" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "ユーザー", -1))
const _hoisted_198 = { class: "centered-text font-bold mt-1" }
const _hoisted_199 = { class: "grid mt-3 justify-content-center" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_201 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, onBeforeUnmount, onMounted, computed, watch } from "vue";

/**
 * Vuexストア関連のインポート
 * @description グローバル状態管理
 */
import { useStore } from "vuex";

/**
 * Vue Router関連のインポート
 * @description ルーティング機能
 */
import { onBeforeRouteLeave, useRouter } from "vue-router";

/**
 * VueUseライブラリのインポート
 * @description Vue.jsのユーティリティ関数
 */
import { get, set } from "@vueuse/core";

/**
 * PrimeVue UIコンポーネントのインポート
 * @description UIコンポーネントライブラリ
 */
import { useToast } from "primevue/usetoast";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import Toast from "primevue/toast";
import SelectButton from "primevue/selectbutton";
import Calendar from "primevue/calendar";
import Dialog from "primevue/dialog";
import InputNumber from "primevue/inputnumber";
import Checkbox from "primevue/checkbox";

/**
 * サードパーティライブラリのインポート
 * @description 外部ライブラリ
 */
import { CircleProgressBar } from "vue3-m-circle-progress-bar";
import moment from "moment";

/**
 * ユーティリティとサービスのインポート
 * @description アプリケーション固有のユーティリティ
 */
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import DistributionGroupUtils from "@/clinic/utils/distribution-group-utils";

/**
 * 定数のインポート
 * @description アプリケーションで使用する定数
 */
import { PLACEHOLDER_SELECT } from "@/clinic/typings/constants/clinic";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";

/**
 * 型定義とenumのインポート
 * @description TypeScript型定義と列挙型
 */
import { DistributionGroupBookingStatusOptions } from "@/clinic/typings/enums/booking";
import { CustomerStatusOptions as DefaultCustomerStatusOptions } from "@/clinic/typings/enums/customer";
import { ApiFilterReq } from "@/clinic/typings/apis/distribution-group";
import {
  AgeFilterOptions,
  FilterTimeOptions,
  TotalVisitMinOptionsAllTime,
  TotalVisitMaxOptionsAllTime,
  TotalVisitMinOptionsCurrentMonth,
  TotalVisitMaxOptionsCurrentMonth,
  TotalVisitMinOptionsThreeMonths,
  TotalVisitMaxOptionsThreeMonths,
  TotalVisitMinOptionsHalfYear,
  TotalVisitMaxOptionsHalfYear,
  TotalVisitMinOptionsOneYear,
  TotalVisitMaxOptionsOneYear,
  TotalVisitMinOptionsCustomPeriod,
  TotalVisitMaxOptionsCustomPeriod,
  MonthlyAverageMinOptions,
  MonthlyAverageMaxOptions,
} from "@/clinic/typings/enums/distribution_group";
import { TagTypeEnum } from "@/clinic/typings/enums/tag";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * コンポーネントのインポート
 * @description 子コンポーネント
 */
import FilterDistributionGroupCustomer from "@/clinic/views/common/DistributionGroup/FilterDistributionGroupCustomer.vue";

/**
 * 画面遷移用のルーターインスタンス
 * @type {Router}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TargetSetting',
  props: {
    isEdit: { type: Boolean },
    finalSetting: { type: Boolean },
    distributionGroupId: null,
    targetInformation: null,
    rejectedCustomerCodes: null
  },
  emits: [
  "resourcesFn",
  "saveTargetInformation",
  "changeTargetViewType",
  "saveTargetCustomers",
  "backFromFinalSetting",
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  isEdit: boolean;
  finalSetting: boolean;
  distributionGroupId: any;
  targetInformation: any;
  rejectedCustomerCodes: any[];
};

/**
 * @file 配信グループターゲット設定コンポーネント
 *
 * このコンポーネントは、配信グループのターゲット設定を行うためのUIを提供する
 * 性別、年齢、来店履歴、タグなどの条件を設定し、配信対象となるユーザーを絞り込む
 *
 */

/**
 * Vue.js関連のインポート
 * @description Vue.jsの基本機能とコンポーネントライフサイクル
 */
const router = useRouter();

/**
 * 次に遷移するルートを保持するためのref
 * @type {Ref<string|null>}
 */
const nextRoute = ref(null);

/**
 * 強制的に画面遷移を許可するフラグ
 * @type {Ref<boolean>}
 */
const hasPermissionRedirect = ref(false);

/**
 * 「保存されていない変更があります」のダイアログ表示制御
 * @type {Ref<boolean>}
 */
const warningRedirectPage = ref(false);

/**
 * イベントを親コンポーネントにEmitする
 * @property {Function} resourcesFn            各ステップのリソース取得処理を再実行するためのイベント
 * @property {Function} saveTargetInformation  現在のフィルター情報を親に保存するためのイベント
 * @property {Function} changeTargetViewType   ステップを戻す際に画面のviewTypeを切り替えるイベント
 * @property {Function} saveTargetCustomers    「選定ユーザーを見る」ボタン押下時などに実行する
 * @property {Function} backFromFinalSetting   最終設定から戻るボタン押下時のイベント
 */


/**
 * 表示用タグのキーを配列で管理
 * @type {string[]}
 */
const displayTags: string[] = [
  "penultimate_booking_services",
  "latest_booking_services",
  "month_birthday",
  "frequency_visit",
  "staffs",
];

/**
 * フィルターに選択されたタグリストを更新する
 * @param {any[]} newVal - 更新後のタグリスト
 */
const updateFilterTags = (newVal: any) => {
  set(filterTags, newVal);
};

/**
 * 最終設定から1つ前のステップに戻る
 */
const backFromFinalStep = () => {
  emits("backFromFinalSetting", 2);
};

/**
 * 「配信設定へ進む」ボタン押下時の処理
 * 非同期でターゲット設定を更新し、次のステップへ進む
 * ただし、フォームの内容に変更があり、「選定ユーザを見る」ボタンが押下されていない場合は、エラー通知を出す
 */
const onNextStep = async () => {
  if (isFormChanged.value) {
    notityErrorMsg(toast, "次へ進む前に選定ユーザを確認してください");
    return;
  }

  // バリデーションチェック
  const validation = validateAmountSettings();
  if (!validation.isValid) {
    validation.errors.forEach(error => {
      notityErrorMsg(toast, error);
    });
    return;
  }

  set(nextStepLoading, true);
  const params = getParams();
  const clinicParam = { clinic_id: clinicId.value };

  const [error] = await handleError(
    DistributionGroupService.updateTargetSettings(props.distributionGroupId, clinicParam, params as ApiFilterReq)
  );

  if (error) {
    notityErrorMsg(toast, "配信設定への遷移に失敗しました");
    set(nextStepLoading, false);
    return;
  }

  set(hasPermissionRedirect, true);
  emits("saveTargetInformation", params);
  set(nextStepLoading, false);
};

/**
 * 「選定ユーザーを見る」ボタン押下時の処理
 * 親コンポーネントに選択済みフィルタ情報を渡し、初期値の値をセットする
 * このタイミングでisFormChangedはfalseとなる
 */
const onSaveTargetCustomers = () => {
  emits("saveTargetCustomers", getParams(), null);
  setInitialForm();
};

/** 選定結果ユーザー数 */
const resultNumber = ref(0);
/** ターゲットユーザー数 */
const totalCustomer = ref(0);

/** カスタマーのタグ一覧（手動タグ） */
const listTags = ref([]);
/** RIPICLEのタグ一覧 */
const partnerTags = ref([]);
/** 手動タグをカテゴリごとにグループ化したオブジェクト */
const manualTagsByCategory = ref<Record<string, any[]>>({});

/** ローディングスピナーの表示非表示 */
const isLoading = ref(false);
/** 「配信設定へ進む」ボタン押下時に表示するスピナーの制御 */
const nextStepLoading = ref(false);

/** Vuexストア */
const store = useStore();

/** Toastの呼び出し */
const toast = useToast();

/** 現在のクリニックID */
const clinicId = ref(0);

/** 下書き保存ダイアログ表示フラグ */
const safeDraftDialog = ref(false);
/** 「ユーザー数を確認」ダイアログ表示フラグ */
const getResultDialog = ref(false);
/** 「前設定へ戻る」際の警告ダイアログ表示フラグ */
const warningReturnVisible = ref(false);

/**
 * 性別フィルター
 * @type {Ref<string>}
 */
const filterGender = ref("all_gender");

/**
 * 年齢テンプレート（「すべて」等）
 * @type {Ref<string[]>}
 */
const filterAges = ref(["すべて"]);

/**
 * 年齢範囲指定 - 開始
 * @type {Ref<number|undefined>}
 */
const filterAgeStart = ref();

/**
 * 年齢範囲指定 - 終了
 * @type {Ref<number|undefined>}
 */
const filterAgeEnd = ref();

/**
 * 年齢指定種別（テンプレート／範囲）
 * @type {Ref<string>}
 */
const filterAgeType = ref("template_age");

/**
 * 期間テンプレート
 * @type {Ref<number>}
 */
const filterTime = ref(0);

/**
 * 期間指定種別（テンプレート／範囲）
 * @type {Ref<string>}
 */
const filterTimeType = ref("template_period");

/**
 * 期間範囲指定 - 開始
 * @type {Ref<Date|undefined>}
 */
const filterTimeStart = ref();

/**
 * 期間範囲指定 - 終了
 * @type {Ref<Date|undefined>}
 */
const filterTimeEnd = ref();

/**
 * タグ選択（自動タグ・手動タグすべてを含む）
 * - タグ選択セグメント配下のタグ全般を管理する
 * @type {Ref<any[]>}
 */
const filterTags = ref([]);

/**
 * 来店ステータス
 * @type {Ref<string[]>}
 */
const bookingStatuses = ref(["full"]);

/**
 * 顧客ステータス
 * @type {Ref<string[]>}
 */
const customerStatuses = ref(["all"]);

/**
 * 顧客ステータスオプション（動的に取得）
 * @type {Ref<Array<{value: string, name: string}>>}
 */
const customerStatusOptions = ref(DefaultCustomerStatusOptions);

/**
 * 最新の予約メニュータグ
 * @type {Ref<any[]>}
 */
const latestBookingMenuTags = ref([]);

/**
 * 前回施術メニュータグ
 * @type {Ref<any[]>}
 */
const penultimateBookingMenuTags = ref([]);

/**
 * 月別誕生日タグ
 * @type {Ref<any[]>}
 */
const monthBirthDayTags = ref([]);

/**
 * 来店頻度タグ
 * @type {Ref<any[]>}
 */
const frequencyVisitTags = ref([]);

/**
 * 1年以内来店回数タグ
 * @type {Ref<any[]>}
 */
const visitsInOneYearTags = ref([]);

/**
 * 半年以内来店回数タグ
 * @type {Ref<any[]>}
 */
const visitsInHalfYearTags = ref([]);

/**
 * 任意期間設定での来店回数タグ
 * @type {Ref<any[]>}
 */
const visitsInCustomPeriodTags = ref([]);

/**
 * 任意期間設定 - 開始日
 * @type {Ref<Date|undefined>}
 */
const customPeriodStart = ref();

/**
 * 任意期間設定 - 終了日
 * @type {Ref<Date|undefined>}
 */
const customPeriodEnd = ref();

/**
 * 利用金額履歴種別（全期間 or 当月）
 * @type {Ref<string>}
 */
const amountHistory = ref("all_time");

/**
 * 利用金額任意期間設定の開始日
 * @type {Ref<Date|undefined>}
 */
const amountCustomPeriodStart = ref();

/**
 * 利用金額任意期間設定の終了日
 * @type {Ref<Date|undefined>}
 */
const amountCustomPeriodEnd = ref();

/**
 * 利用金額範囲
 * @type {Ref<{min: number, max: number}>}
 */
/** 総利用金額の最小値 */
const totalAmountMin = ref("no_min");

/** 総利用金額の最大値 */
const totalAmountMax = ref("no_max");

/** 月平均利用金額の最小値 */
const monthlyAverageAmountMin = ref("no_min");

/** 月平均利用金額の最大値 */
const monthlyAverageAmountMax = ref("no_max");

// 新しい自由入力用の変数
/** 総利用金額下限なしフラグ */
const totalAmountMinNoLimit = ref(true);

/** 総利用金額上限なしフラグ */
const totalAmountMaxNoLimit = ref(true);

/** 総利用金額下限値（自由入力） */
const totalAmountMinValue = ref<number | undefined>(undefined);

/** 総利用金額上限値（自由入力） */
const totalAmountMaxValue = ref<number | undefined>(undefined);

/** 月平均利用金額下限なしフラグ */
const monthlyAverageAmountMinNoLimit = ref(true);

/** 月平均利用金額上限なしフラグ */
const monthlyAverageAmountMaxNoLimit = ref(true);

/** 月平均利用金額下限値（自由入力） */
const monthlyAverageAmountMinValue = ref<number | undefined>(undefined);

/** 月平均利用金額上限値（自由入力） */
const monthlyAverageAmountMaxValue = ref<number | undefined>(undefined);

/** 平均単価下限なしフラグ */
const averagePriceMinNoLimit = ref(true);

/** 平均単価上限なしフラグ */
const averagePriceMaxNoLimit = ref(true);

/** 平均単価下限値（自由入力） */
const averagePriceMinValue = ref<number | undefined>(undefined);

/** 平均単価上限値（自由入力） */
const averagePriceMaxValue = ref<number | undefined>(undefined);

/**
 * 指名スタッフタグ
 * @type {Ref<any[]>}
 */
const staffTags = ref([]);

/**
 * 悩みタグ（動的に生成される）
 * @type {Ref<Record<string, {tags: any[]; displayName: string}>>}
 */
const problemTags = ref<Record<string, { tags: any[]; displayName: string }>>({});

/**
 * 動的に取得した悩みカテゴリのキー
 * @type {Ref<string[]>}
 */
const dynamicProblemKeys = ref<string[]>([]);

/**
 * 年齢セレクト用のオプション（1〜100歳）
 * @type {Array<{label: string, value: number}>}
 */
const ageRangeOptions = Array.from({ length: 100 }, (_, i) => ({ label: (i + 1).toString() + "歳", value: i + 1 }));

/**
 * 来店履歴の選択種別（「全期間選択」または「当月内選択」など）
 * @type {Ref<string>}
 */
const visitHistory = ref("all_time");

/**
 * 全期間選択時の選択肢
 * @type {Ref<any[]>}
 */
const allTimeVisitHistorySettings = ref([]);

/**
 * 当月内選択時の選択肢
 * @type {Ref<any[]>}
 */
const currentMonthVisitHistorySettings = ref([]);

/**
 * 3ヶ月以内来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const threeMonthsVisitHistorySettings = ref([]);

/**
 * 1年以内来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const oneYearVisitHistorySettings = ref([]);

/**
 * 半年以内来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const halfYearVisitHistorySettings = ref([]);

/**
 * 任意期間での来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const customPeriodVisitHistorySettings = ref([]);

/**
 * 全期間月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const allTimeMonthlyAverageSettings = ref([]);

/**
 * 当月内月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const currentMonthMonthlyAverageSettings = ref([]);

/**
 * 3ヶ月以内月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const threeMonthsMonthlyAverageSettings = ref([]);

/**
 * 1年以内月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const oneYearMonthlyAverageSettings = ref([]);

/**
 * 半年以内月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const halfYearMonthlyAverageSettings = ref([]);

/**
 * 任意期間月平均来店回数時の選択肢
 * @type {Ref<any[]>}
 */
const customPeriodMonthlyAverageSettings = ref([]);

/**
 * カスタム総来店回数の最小値
 * @type {Ref<string|undefined>}
 */
const customTotalVisitMin = ref("no_min");

/**
 * カスタム総来店回数の最大値
 * @type {Ref<string|undefined>}
 */
const customTotalVisitMax = ref("no_max");

/**
 * カスタム月平均来店回数の最小値
 * @type {Ref<string|undefined>}
 */
const customMonthlyAverageMin = ref("no_min");

/**
 * カスタム月平均来店回数の最大値
 * @type {Ref<string|undefined>}
 */
const customMonthlyAverageMax = ref("no_max");

/**
 * 初期フォーム内容を保持するためのref（パラメータ変更時の比較に使用）
 * @type {Ref<any>}
 */
const initialForm = ref<any>({
  gender: filterGender.value,
  ages: filterAges.value,
  ageStart: filterAgeStart.value,
  ageEnd: filterAgeEnd.value,
  ageType: filterAgeType.value,
  time: filterTime.value,
  timeType: filterTimeType.value,
  timeStart: filterTimeStart.value,
  timeEnd: filterTimeEnd.value,
  bookingStatuses: bookingStatuses.value,
  customerStatuses: customerStatuses.value,
  visitHistory: visitHistory.value,
  allTimeVisitHistorySettings: allTimeVisitHistorySettings.value,
  currentMonthVisitHistorySettings: currentMonthVisitHistorySettings.value,
  threeMonthsVisitHistorySettings: threeMonthsVisitHistorySettings.value,
  filterTags: filterTags.value,
});

/**
 * props定義
 * @typedef {object} Props
 * @property {boolean} isEdit               - 新規作成か編集モードかを判定するフラグ
 * @property {boolean} finalSetting         - 最終設定かどうかを判定するフラグ
 * @property {any} distributionGroupId      - 配信グループID
 * @property {any} targetInformation        - 既に設定されているターゲット情報
 * @property {any[]} rejectedCustomerCodes - 除外対象の顧客コード配列
 */


/**
 * 来店履歴ボタン切り替え時の処理
 * @param {string} _value - 選択された期間タイプ（未使用）
 */
const onChangeVisitHistory = (_value: string) => {
  // すべての個別設定をクリア
  set(allTimeVisitHistorySettings, []);
  set(allTimeMonthlyAverageSettings, []);
  set(currentMonthVisitHistorySettings, []);
  set(currentMonthMonthlyAverageSettings, []);
  set(threeMonthsVisitHistorySettings, []);
  set(threeMonthsMonthlyAverageSettings, []);
  set(oneYearVisitHistorySettings, []);
  set(oneYearMonthlyAverageSettings, []);
  set(halfYearVisitHistorySettings, []);
  set(halfYearMonthlyAverageSettings, []);
  set(customPeriodVisitHistorySettings, []);
  set(customPeriodMonthlyAverageSettings, []);

  // カスタム入力の初期化
  set(customTotalVisitMin, "no_min");
  set(customTotalVisitMax, "no_max");
  set(customMonthlyAverageMin, "no_min");
  set(customMonthlyAverageMax, "no_max");
};

/**
 * 利用金額履歴のセレクト切替
 * @function onChangeAmountHistory
 * @param {string} _value - 選択された利用金額履歴タイプ（未使用）
 * @returns {void}
 */
const onChangeAmountHistory = (_value: string) => {
  // 利用金額範囲をリセット
  set(totalAmountMin, "no_min");
  set(totalAmountMax, "no_max");
  set(monthlyAverageAmountMin, "no_min");
  set(monthlyAverageAmountMax, "no_max");

  // 新しい自由入力形式の変数もリセット
  totalAmountMinNoLimit.value = true;
  totalAmountMaxNoLimit.value = true;
  totalAmountMinValue.value = undefined;
  totalAmountMaxValue.value = undefined;
  monthlyAverageAmountMinNoLimit.value = true;
  monthlyAverageAmountMaxNoLimit.value = true;
  monthlyAverageAmountMinValue.value = undefined;
  monthlyAverageAmountMaxValue.value = undefined;
};

// 新しい自由入力用の関数
/**
 * 総利用金額下限なしチェックボックス変更時の処理
 */
const onTotalAmountMinNoLimitChange = () => {
  if (totalAmountMinNoLimit.value) {
    totalAmountMinValue.value = undefined;
    // 下限なしがチェックされた場合、エラーメッセージをクリア
    showTotalAmountError.value = false;
    showTotalAmountRangeError.value = false;
  }
};

/**
 * 総利用金額上限なしチェックボックス変更時の処理
 */
const onTotalAmountMaxNoLimitChange = () => {
  if (totalAmountMaxNoLimit.value) {
    totalAmountMaxValue.value = undefined;
    // 上限なしがチェックされた場合、エラーメッセージをクリア
    showTotalAmountError.value = false;
    showTotalAmountRangeError.value = false;
  }
};

/**
 * 月平均利用金額下限なしチェックボックス変更時の処理
 */
const onMonthlyAverageAmountMinNoLimitChange = () => {
  if (monthlyAverageAmountMinNoLimit.value) {
    monthlyAverageAmountMinValue.value = undefined;
    // 下限なしがチェックされた場合、エラーメッセージをクリア
    showMonthlyAverageError.value = false;
    showMonthlyAverageRangeError.value = false;
  }
};

/**
 * 月平均利用金額上限なしチェックボックス変更時の処理
 */
const onMonthlyAverageAmountMaxNoLimitChange = () => {
  if (monthlyAverageAmountMaxNoLimit.value) {
    monthlyAverageAmountMaxValue.value = undefined;
    // 上限なしがチェックされた場合、エラーメッセージをクリア
    showMonthlyAverageError.value = false;
    showMonthlyAverageRangeError.value = false;
  }
};

/**
 * エラーメッセージの表示状態（個別管理）
 */
const showTotalAmountError = ref(false);
const showMonthlyAverageError = ref(false);
const showTotalAmountRangeError = ref(false);
const showMonthlyAverageRangeError = ref(false);
const showCustomPeriodDateError = ref(false);
const showAmountCustomPeriodDateError = ref(false);
const showAveragePriceError = ref(false);
const showAveragePriceRangeError = ref(false);

/**
 * 範囲エラーメッセージの内容
 */
const totalAmountRangeErrorMessage = ref("");
const monthlyAverageRangeErrorMessage = ref("");
const averagePriceRangeErrorMessage = ref("");

/**
 * フォーカス状態を追跡する変数
 */
const isTotalAmountMaxFocused = ref(false);
const isMonthlyAverageMaxFocused = ref(false);
const isAveragePriceMaxFocused = ref(false);

/**
 * 数字以外の入力を防ぐ（下限用）
 */
const preventNonNumericInputTotal = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showTotalAmountError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkTotalAmountRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showTotalAmountError.value = true;
};

/**
 * 数字以外の入力を防ぐ（上限用）
 */
const preventNonNumericInputTotalMax = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showTotalAmountError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkTotalAmountMaxRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showTotalAmountError.value = true;
};

/**
 * 月平均用: 数字以外の入力を防ぐ（下限用）
 */
const preventNonNumericInputMonthly = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showMonthlyAverageError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkMonthlyAverageRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showMonthlyAverageError.value = true;
};

/**
 * 月平均用: 数字以外の入力を防ぐ（上限用）
 */
const preventNonNumericInputMonthlyMax = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showMonthlyAverageError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkMonthlyAverageMaxRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showMonthlyAverageError.value = true;
};

/**
 * ペースト時の処理
 */
const handlePaste = (event: ClipboardEvent) => {
  event.preventDefault();
  const pastedText = event.clipboardData?.getData("text") || "";
  const numericValue = pastedText.replace(/[^0-9]/g, "");
  if (numericValue) {
    const target = event.target as HTMLInputElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;
    const currentValue = target.value;
    const newValue = currentValue.substring(0, start) + numericValue + currentValue.substring(end);
    target.value = newValue;
    target.setSelectionRange(start + numericValue.length, start + numericValue.length);
  }
};

/**
 * 総利用金額用: 日本語入力開始時の処理
 */
const handleCompositionStartTotal = (event: CompositionEvent) => {
  // 日本語入力が開始された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showTotalAmountError.value = true;
    }
  }
};

/**
 * 月平均用: 日本語入力開始時の処理
 */
const handleCompositionStartMonthly = (event: CompositionEvent) => {
  // 日本語入力が開始された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showMonthlyAverageError.value = true;
    }
  }
};

/**
 * 総利用金額用: 日本語入力更新時の処理
 */
const handleCompositionUpdateTotal = (event: CompositionEvent) => {
  // 日本語入力が更新された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showTotalAmountError.value = true;
    }
  }
};

/**
 * 月平均用: 日本語入力更新時の処理
 */
const handleCompositionUpdateMonthly = (event: CompositionEvent) => {
  // 日本語入力が更新された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showMonthlyAverageError.value = true;
    }
  }
};

/**
 * 平均単価用: 数字以外の入力を防ぐ（下限用）
 */
const preventNonNumericInputAveragePrice = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showAveragePriceError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkAveragePriceRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showAveragePriceError.value = true;
};

/**
 * 平均単価用: 数字以外の入力を防ぐ（上限用）
 */
const preventNonNumericInputAveragePriceMax = (event: KeyboardEvent) => {
  // 数字（0-9）、バックスペース、Delete、矢印キー、Tab、Enter、Home、End、小数点を許可
  const allowedKeys = [8, 9, 13, 35, 36, 37, 38, 39, 40, 46, 110, 190]; // バックスペース、Tab、Enter、Home、End、矢印キー、Delete、小数点
  const charCode = event.which ? event.which : event.keyCode;

  // 数字（0-9）の場合はエラーメッセージを非表示
  if (charCode >= 48 && charCode <= 57) {
    showAveragePriceError.value = false;
    return;
  }

  // エンターキー（13）の場合、範囲チェックを実行
  if (charCode === 13) {
    checkAveragePriceMaxRange();
    return;
  }

  // 許可されたキーの場合は何もしない
  if (allowedKeys.includes(charCode)) {
    return;
  }

  // その他のキーは無効化
  event.preventDefault();

  // エラーメッセージを表示
  showAveragePriceError.value = true;
};

/**
 * 平均単価用: 日本語入力開始時の処理
 */
const handleCompositionStartAveragePrice = (event: CompositionEvent) => {
  // 日本語入力が開始された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showAveragePriceError.value = true;
    }
  }
};

/**
 * 平均単価用: 日本語入力更新時の処理
 */
const handleCompositionUpdateAveragePrice = (event: CompositionEvent) => {
  // 日本語入力が更新された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showAveragePriceError.value = true;
    }
  }
};

/**
 * 平均単価用: 日本語入力終了時の処理
 */
const handleCompositionEndAveragePrice = (event: CompositionEvent) => {
  // 日本語入力が終了された場合、エラーを表示
  if (event.data && event.data.length > 0) {
    const numericValue = event.data.replace(/[^0-9]/g, "");
    if (numericValue.length === 0) {
      showAveragePriceError.value = true;
    }
  }
};

/**
 * 総利用金額用: 日本語入力確定時の処理
 */
const handleCompositionEndTotal = (event: CompositionEvent) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;
  // 通貨形式の文字（¥、,）を除去して数字のみを抽出
  const numericValue = value.toString().replace(/[^0-9]/g, "");

  // 数字以外の文字が含まれている場合はエラーメッセージを表示
  if (value.toString().replace(/[¥,\s]/g, "") !== numericValue) {
    showTotalAmountError.value = true;
  } else {
    showTotalAmountError.value = false;
  }
};

/**
 * 月平均用: 日本語入力確定時の処理
 */
const handleCompositionEndMonthly = (event: CompositionEvent) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;
  // 通貨形式の文字（¥、,）を除去して数字のみを抽出
  const numericValue = value.toString().replace(/[^0-9]/g, "");

  // 数字以外の文字が含まれている場合はエラーメッセージを表示
  if (value.toString().replace(/[¥,\s]/g, "") !== numericValue) {
    showMonthlyAverageError.value = true;
  } else {
    showMonthlyAverageError.value = false;
  }
};

/**
 * 総利用金額用: InputNumberコンポーネントのマウント後の処理
 */
const handleInputNumberMountedTotal = (event: Event) => {
  const target = event.target as HTMLElement;
  const inputElement = target.querySelector("input") as HTMLInputElement;
  if (inputElement) {
    // 日本語入力確定時のイベントリスナーを追加
    inputElement.addEventListener("compositionend", handleCompositionEndTotal);
  }
};

/**
 * 月平均用: InputNumberコンポーネントのマウント後の処理
 */
const handleInputNumberMountedMonthly = (event: Event) => {
  const target = event.target as HTMLElement;
  const inputElement = target.querySelector("input") as HTMLInputElement;
  if (inputElement) {
    // 日本語入力確定時のイベントリスナーを追加
    inputElement.addEventListener("compositionend", handleCompositionEndMonthly);
  }
};

/**
 * 総利用金額用: 数字入力時のエラー処理（下限用）
 */
const handleNumericInputTotal = (event: any) => {
  // InputNumberコンポーネントの値が変更された場合の処理
  if (typeof event === "number" && event !== null && event !== undefined) {
    // 有効な数値が入力された場合はエラーをクリア
    showTotalAmountError.value = false;
    // 範囲チェックを実行
    setTimeout(() => {
      checkTotalAmountRange();
    }, 0);
  } else if (event === null || event === undefined) {
    // 値がクリアされた場合、実際のinput要素の値をチェック
    setTimeout(() => {
      checkAllInputValuesTotal();
      checkTotalAmountRange();
    }, 0);
  } else {
    // 無効な値の場合はエラーを表示
    showTotalAmountError.value = true;
  }
};

/**
 * 総利用金額用: 数字入力時のエラー処理（上限用）
 */
const handleNumericInputTotalMax = (event: any) => {
  // InputNumberコンポーネントの値が変更された場合の処理
  if (typeof event === "number" && event !== null && event !== undefined) {
    // 有効な数値が入力された場合はエラーをクリア
    showTotalAmountError.value = false;
    // 範囲チェックを実行
    setTimeout(() => {
      checkTotalAmountRange();
    }, 0);
  } else if (event === null || event === undefined) {
    // 値がクリアされた場合、実際のinput要素の値をチェック
    setTimeout(() => {
      checkAllInputValuesTotal();
      checkTotalAmountRange();
    }, 0);
  } else {
    // 無効な値の場合はエラーを表示
    showTotalAmountError.value = true;
  }
};

/**
 * 総利用金額下限用: フォーカスイベントハンドラー
 */
const handleFocusTotal = () => {
  isTotalAmountMaxFocused.value = false;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkTotalAmountRange();
  }, 0);
};

/**
 * 総利用金額上限用: フォーカスイベントハンドラー
 */
const handleFocusTotalMax = () => {
  isTotalAmountMaxFocused.value = true;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkTotalAmountRange();
  }, 0);
};

/**
 * 月平均利用金額下限用: フォーカスイベントハンドラー
 */
const handleFocusMonthly = () => {
  isMonthlyAverageMaxFocused.value = false;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkMonthlyAverageRange();
  }, 0);
};

/**
 * 月平均利用金額上限用: フォーカスイベントハンドラー
 */
const handleFocusMonthlyMax = () => {
  isMonthlyAverageMaxFocused.value = true;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkMonthlyAverageRange();
  }, 0);
};

/**
 * 平均単価下限用: フォーカスイベントハンドラー
 */
const handleFocusAveragePrice = () => {
  isAveragePriceMaxFocused.value = false;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkAveragePriceRange();
  }, 0);
};

/**
 * 平均単価上限用: フォーカスイベントハンドラー
 */
const handleFocusAveragePriceMax = () => {
  isAveragePriceMaxFocused.value = true;
  // フォーカス時に範囲チェックを実行してエラーメッセージを更新
  setTimeout(() => {
    checkAveragePriceRange();
  }, 0);
};

/**
 * 月平均用: 数字入力時のエラー処理（下限用）
 */
const handleNumericInputMonthly = (event: any) => {
  // InputNumberコンポーネントの値が変更された場合の処理
  if (typeof event === "number" && event !== null && event !== undefined) {
    // 有効な数値が入力された場合はエラーをクリア
    showMonthlyAverageError.value = false;
    // 範囲チェックを実行
    setTimeout(() => {
      checkMonthlyAverageRange();
    }, 0);
  } else if (event === null || event === undefined) {
    // 値がクリアされた場合、実際のinput要素の値をチェック
    setTimeout(() => {
      checkAllInputValuesMonthly();
      checkMonthlyAverageRange();
    }, 0);
  } else {
    // 無効な値の場合はエラーを表示
    showMonthlyAverageError.value = true;
  }
};

/**
 * 月平均用: 数字入力時のエラー処理（上限用）
 */
const handleNumericInputMonthlyMax = (event: any) => {
  // InputNumberコンポーネントの値が変更された場合の処理
  if (typeof event === "number" && event !== null && event !== undefined) {
    // 有効な数値が入力された場合はエラーをクリア
    showMonthlyAverageError.value = false;
    // 範囲チェックを実行
    setTimeout(() => {
      checkMonthlyAverageMaxRange();
    }, 0);
  } else if (event === null || event === undefined) {
    // 値がクリアされた場合、実際のinput要素の値をチェック
    setTimeout(() => {
      checkAllInputValuesMonthly();
      checkMonthlyAverageMaxRange();
    }, 0);
  } else {
    // 無効な値の場合はエラーを表示
    showMonthlyAverageError.value = true;
  }
};

/**
 * 総利用金額用: InputNumberの実際の値をチェック
 */
const checkAllInputValuesTotal = () => {
  // InputNumberコンポーネントの内部のinput要素の値をチェック
  const inputElements = document.querySelectorAll(".amount-input input");
  let hasError = false;

  inputElements.forEach(input => {
    const value = (input as HTMLInputElement).value;

    if (value) {
      // 通貨形式の文字（¥、￥、,）を除去して数字のみを抽出
      const cleanValue = value.toString().replace(/[¥￥,\s]/g, "");
      const numericValue = cleanValue.replace(/[^0-9]/g, "");

      // 数字以外の文字が含まれている場合はエラーを表示
      if (cleanValue !== numericValue) {
        hasError = true;
      }
    }
  });

  // エラーがある場合のみ設定（エラーがない場合は既存の状態を維持）
  if (hasError) {
    showTotalAmountError.value = true;
  }
};

/**
 * 月平均用: InputNumberの実際の値をチェック
 */
const checkAllInputValuesMonthly = () => {
  // InputNumberコンポーネントの内部のinput要素の値をチェック
  const inputElements = document.querySelectorAll(".amount-input input");
  let hasError = false;

  inputElements.forEach(input => {
    const value = (input as HTMLInputElement).value;

    if (value) {
      // 通貨形式の文字（¥、￥、,）を除去して数字のみを抽出
      const cleanValue = value.toString().replace(/[¥￥,\s]/g, "");
      const numericValue = cleanValue.replace(/[^0-9]/g, "");

      // 数字以外の文字が含まれている場合はエラーを表示
      if (cleanValue !== numericValue) {
        hasError = true;
      }
    }
  });

  // エラーがある場合のみ設定（エラーがない場合は既存の状態を維持）
  if (hasError) {
    showMonthlyAverageError.value = true;
  }
};

/**
 * 総利用金額用: フォーカスが外れた際のチェック（下限用）
 */
const handleBlurTotal = () => {
  // フォーカスが外れた際に、すべてのinput要素の値をチェック
  setTimeout(() => {
    checkAllInputValuesTotal();
    // 範囲チェックも実行
    checkTotalAmountRange();
  }, 0);
};

/**
 * 総利用金額用: フォーカスが外れた際のチェック（上限用）
 */
const handleBlurTotalMax = () => {
  // フォーカス状態をリセット
  isTotalAmountMaxFocused.value = false;

  // フォーカスが外れた際に、すべてのinput要素の値をチェック
  setTimeout(() => {
    checkAllInputValuesTotal();
    // 範囲チェックも実行
    checkTotalAmountRange();
  }, 0);
};

/**
 * 月平均用: フォーカスが外れた際のチェック（下限用）
 */
const handleBlurMonthly = () => {
  // フォーカスが外れた際に、すべてのinput要素の値をチェック
  setTimeout(() => {
    checkAllInputValuesMonthly();
    // 範囲チェックも実行
    checkMonthlyAverageRange();
  }, 0);
};

/**
 * 月平均用: フォーカスが外れた際のチェック（上限用）
 */
const handleBlurMonthlyMax = () => {
  // フォーカス状態をリセット
  isMonthlyAverageMaxFocused.value = false;

  // フォーカスが外れた際に、すべてのinput要素の値をチェック
  setTimeout(() => {
    checkAllInputValuesMonthly();
    // 範囲チェックも実行
    checkMonthlyAverageRange();
  }, 0);
};

/**
 * 総利用金額の範囲チェック
 */
const checkTotalAmountRange = () => {
  if (
    !totalAmountMinNoLimit.value &&
    !totalAmountMaxNoLimit.value &&
    totalAmountMinValue.value !== undefined &&
    totalAmountMaxValue.value !== undefined
  ) {
    if (totalAmountMinValue.value > totalAmountMaxValue.value) {
      showTotalAmountRangeError.value = true;
      // フォーカス状態に応じてエラーメッセージを動的に変更
      if (isTotalAmountMaxFocused.value) {
        totalAmountRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      } else {
        totalAmountRangeErrorMessage.value = "下限金額は上限金額より小さい値を入力してください";
      }
      return;
    }
  }
  showTotalAmountRangeError.value = false;
  totalAmountRangeErrorMessage.value = "";
};

/**
 * 月平均利用金額の範囲チェック
 */
const checkMonthlyAverageRange = () => {
  if (
    !monthlyAverageAmountMinNoLimit.value &&
    !monthlyAverageAmountMaxNoLimit.value &&
    monthlyAverageAmountMinValue.value !== undefined &&
    monthlyAverageAmountMaxValue.value !== undefined
  ) {
    if (monthlyAverageAmountMinValue.value > monthlyAverageAmountMaxValue.value) {
      showMonthlyAverageRangeError.value = true;
      // フォーカス状態に応じてエラーメッセージを動的に変更
      if (isMonthlyAverageMaxFocused.value) {
        monthlyAverageRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      } else {
        monthlyAverageRangeErrorMessage.value = "下限金額は上限金額より小さい値を入力してください";
      }
      return;
    }
  }
  showMonthlyAverageRangeError.value = false;
  monthlyAverageRangeErrorMessage.value = "";
};

/**
 * 総利用金額上限の範囲チェック
 */
const checkTotalAmountMaxRange = () => {
  if (
    !totalAmountMinNoLimit.value &&
    !totalAmountMaxNoLimit.value &&
    totalAmountMinValue.value !== undefined &&
    totalAmountMaxValue.value !== undefined
  ) {
    if (totalAmountMinValue.value > totalAmountMaxValue.value) {
      showTotalAmountRangeError.value = true;
      // 上限が下限より小さい場合のメッセージ
      totalAmountRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      return;
    }
  }
  showTotalAmountRangeError.value = false;
  totalAmountRangeErrorMessage.value = "";
};

/**
 * 月平均利用金額上限の範囲チェック
 */
const checkMonthlyAverageMaxRange = () => {
  if (
    !monthlyAverageAmountMinNoLimit.value &&
    !monthlyAverageAmountMaxNoLimit.value &&
    monthlyAverageAmountMinValue.value !== undefined &&
    monthlyAverageAmountMaxValue.value !== undefined
  ) {
    if (monthlyAverageAmountMinValue.value > monthlyAverageAmountMaxValue.value) {
      showMonthlyAverageRangeError.value = true;
      // 上限が下限より小さい場合のメッセージ
      monthlyAverageRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      return;
    }
  }
  showMonthlyAverageRangeError.value = false;
  monthlyAverageRangeErrorMessage.value = "";
};

/**
 * 平均単価の範囲チェック
 */
const checkAveragePriceRange = () => {
  if (
    !averagePriceMinNoLimit.value &&
    !averagePriceMaxNoLimit.value &&
    averagePriceMinValue.value !== undefined &&
    averagePriceMaxValue.value !== undefined
  ) {
    if (averagePriceMinValue.value > averagePriceMaxValue.value) {
      showAveragePriceRangeError.value = true;
      // フォーカス状態に応じてエラーメッセージを動的に変更
      if (isAveragePriceMaxFocused.value) {
        averagePriceRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      } else {
        averagePriceRangeErrorMessage.value = "下限金額は上限金額より小さい値を入力してください";
      }
      return;
    }
  }
  showAveragePriceRangeError.value = false;
  averagePriceRangeErrorMessage.value = "";
};

/**
 * 平均単価上限の範囲チェック
 */
const checkAveragePriceMaxRange = () => {
  if (
    !averagePriceMinNoLimit.value &&
    !averagePriceMaxNoLimit.value &&
    averagePriceMinValue.value !== undefined &&
    averagePriceMaxValue.value !== undefined
  ) {
    if (averagePriceMinValue.value > averagePriceMaxValue.value) {
      showAveragePriceRangeError.value = true;
      // 上限が下限より小さい場合のメッセージ
      averagePriceRangeErrorMessage.value = "上限金額は下限金額より大きい値を入力してください";
      return;
    }
  }
  showAveragePriceRangeError.value = false;
  averagePriceRangeErrorMessage.value = "";
};

/**
 * 任意期間の日付範囲チェック
 */
const checkCustomPeriodDateRange = () => {
  if (customPeriodStart.value && customPeriodEnd.value) {
    if (customPeriodStart.value > customPeriodEnd.value) {
      showCustomPeriodDateError.value = true;
      return;
    }
  }
  showCustomPeriodDateError.value = false;
};

/**
 * 利用金額設定の任意期間の日付範囲チェック
 */
const checkAmountCustomPeriodDateRange = () => {
  if (amountCustomPeriodStart.value && amountCustomPeriodEnd.value) {
    if (amountCustomPeriodStart.value > amountCustomPeriodEnd.value) {
      showAmountCustomPeriodDateError.value = true;
      return;
    }
  }
  showAmountCustomPeriodDateError.value = false;
};

/**
 * 新しい自由入力形式の値を既存の変数に同期する
 */
const syncAmountValues = () => {
  // 総利用金額の同期
  if (totalAmountMinNoLimit.value) {
    set(totalAmountMin, "no_min");
  } else {
    set(totalAmountMin, totalAmountMinValue.value ? String(totalAmountMinValue.value) : "no_min");
  }

  if (totalAmountMaxNoLimit.value) {
    set(totalAmountMax, "no_max");
  } else {
    set(totalAmountMax, totalAmountMaxValue.value ? String(totalAmountMaxValue.value) : "no_max");
  }

  // 月平均利用金額の同期
  if (monthlyAverageAmountMinNoLimit.value) {
    set(monthlyAverageAmountMin, "no_min");
  } else {
    set(
      monthlyAverageAmountMin,
      monthlyAverageAmountMinValue.value ? String(monthlyAverageAmountMinValue.value) : "no_min"
    );
  }

  if (monthlyAverageAmountMaxNoLimit.value) {
    set(monthlyAverageAmountMax, "no_max");
  } else {
    set(
      monthlyAverageAmountMax,
      monthlyAverageAmountMaxValue.value ? String(monthlyAverageAmountMaxValue.value) : "no_max"
    );
  }

  // 平均単価の同期
  if (averagePriceMinNoLimit.value) {
    // 平均単価の下限なしがチェックされた場合、入力値をクリア
    averagePriceMinValue.value = undefined;
  }

  if (averagePriceMaxNoLimit.value) {
    // 平均単価の上限なしがチェックされた場合、入力値をクリア
    averagePriceMaxValue.value = undefined;
  }
};

/**
 * 選択された期間に応じて総来店回数の最小値オプションを取得
 * @function getTotalVisitMinOptions
 * @returns {Array} 総来店回数の最小値オプション配列
 */
const getTotalVisitMinOptions = () => {
  let options;
  switch (visitHistory.value) {
    case "all_time":
      options = TotalVisitMinOptionsAllTime;
      break;
    case "current_month":
      options = TotalVisitMinOptionsCurrentMonth;
      break;
    case "three_months":
      options = TotalVisitMinOptionsThreeMonths;
      break;
    case "one_year":
      options = TotalVisitMinOptionsOneYear;
      break;
    case "half_year":
      options = TotalVisitMinOptionsHalfYear;
      break;
    case "custom_period":
      options = TotalVisitMinOptionsCustomPeriod;
      break;
    default:
      options = TotalVisitMinOptionsAllTime;
  }

  // 上限値に基づいて選択肢をフィルタリング
  const maxValue = get(customTotalVisitMax);
  if (maxValue && maxValue !== "no_max") {
    const maxNum = parseInt(maxValue);
    if (!isNaN(maxNum)) {
      options = options.filter((option: any) => {
        if (option.value === "no_min") return true; // 「下限なし」は常に表示
        const optionNum = parseInt(option.value);
        return isNaN(optionNum) || optionNum <= maxNum;
      });
    }
  }

  return options;
};

/**
 * 選択された期間に応じて総来店回数の最大値オプションを取得
 * @function getTotalVisitMaxOptions
 * @returns {Array} 総来店回数の最大値オプション配列
 */
const getTotalVisitMaxOptions = () => {
  let options;
  switch (visitHistory.value) {
    case "all_time":
      options = TotalVisitMaxOptionsAllTime;
      break;
    case "current_month":
      options = TotalVisitMaxOptionsCurrentMonth;
      break;
    case "three_months":
      options = TotalVisitMaxOptionsThreeMonths;
      break;
    case "one_year":
      options = TotalVisitMaxOptionsOneYear;
      break;
    case "half_year":
      options = TotalVisitMaxOptionsHalfYear;
      break;
    case "custom_period":
      options = TotalVisitMaxOptionsCustomPeriod;
      break;
    default:
      options = TotalVisitMaxOptionsAllTime;
  }

  // 下限値に基づいて選択肢をフィルタリング
  const minValue = get(customTotalVisitMin);
  if (minValue && minValue !== "no_min") {
    const minNum = parseInt(minValue);
    if (!isNaN(minNum)) {
      options = options.filter((option: any) => {
        if (option.value === "no_max") return true; // 「上限なし」は常に表示
        const optionNum = parseInt(option.value);
        return isNaN(optionNum) || optionNum >= minNum;
      });
    }
  }

  return options;
};

/**
 * 選択された期間に応じて月平均来店回数の最小値オプションを取得
 * @function getMonthlyAverageMinOptions
 * @returns {Array} 月平均来店回数の最小値オプション配列
 */
const getMonthlyAverageMinOptions = () => {
  let options = MonthlyAverageMinOptions;

  // 上限値に基づいて選択肢をフィルタリング
  const maxValue = get(customMonthlyAverageMax);
  if (maxValue && maxValue !== "no_max") {
    if (maxValue === "less_1") {
      // 上限が「1回未満」の場合は「1回未満」のみ表示
      options = options.filter((option: any) => option.value === "less_1");
    } else {
      const maxNum = parseInt(maxValue);
      if (!isNaN(maxNum)) {
        options = options.filter((option: any) => {
          if (option.value === "no_min") return true; // 「下限なし」は常に表示
          if (option.value === "less_1") return true; // 「1回未満」は常に表示
          const optionNum = parseInt(option.value);
          return isNaN(optionNum) || optionNum <= maxNum;
        });
      }
    }
  }

  return options;
};

/**
 * 選択された期間に応じて月平均来店回数の最大値オプションを取得
 * @function getMonthlyAverageMaxOptions
 * @returns {Array} 月平均来店回数の最大値オプション配列
 */
const getMonthlyAverageMaxOptions = () => {
  let options = MonthlyAverageMaxOptions;

  // 下限値に基づいて選択肢をフィルタリング
  const minValue = get(customMonthlyAverageMin);
  if (minValue && minValue !== "no_min") {
    if (minValue === "less_1") {
      // 「1回未満」の場合は全ての選択肢を表示
      return options;
    }
    const minNum = parseInt(minValue);
    if (!isNaN(minNum)) {
      options = options.filter((option: any) => {
        if (option.value === "no_max") return true; // 「上限なし」は常に表示
        if (option.value === "less_1") {
          // 「1回未満」は下限が数値の場合のみ表示
          return minValue === "less_1";
        }
        const optionNum = parseInt(option.value);
        return isNaN(optionNum) || optionNum >= minNum;
      });
    }
  }

  return options;
};

/**
 * 「前設定へ戻る」ボタン押下時の処理
 * props.targetInformationと現在のフォーム状態が異なるかどうか判定し、
 * 変更があれば警告ダイアログを出す
 */
const onCheckSaveDraft = () => {
  if (props.targetInformation) {
    const params = getParams();
    let areEqual = Object.keys(props.targetInformation).every(key => props.targetInformation[key] == params[key]);
    areEqual ? onPreviousStep() : (warningReturnVisible.value = true);
  } else {
    warningReturnVisible.value = true;
  }
};

/**
 * 自動タグを取得し、タグごとに加工・格納する
 * @param {Record<string, any[]>} automaticTags - APIから取得した自動タグをまとめたオブジェクト
 */
const setAutomaticTags = (automatic_tags: Record<string, any>) => {
  for (let tagType in automatic_tags) {
    if (tagType.startsWith("problem_")) {
      const tagData = DistributionGroupUtils.assignTagFormat(automatic_tags[tagType].value, tagType, null);
      const displayName = automatic_tags[tagType].name_ja;
      problemTags.value[tagType] = {
        tags: tagData,
        displayName: displayName,
      };
    } else {
      const assignFunction = assignAutomaticTags(tagType);
      if (assignFunction) {
        assignFunction(automatic_tags);
      }
    }
  }
};

/**
 * 自動タグの種類に応じてそれぞれの設定関数を返す
 * @param {string} tagType - 自動タグのキー
 * @returns {Function|null} 呼び出すべき設定関数
 */
const assignAutomaticTags = (tagType: string) => {
  const functionMap: { [key: string]: (tags: any) => void } = {
    latest_booking_services: assignLatestBookingServices,
    penultimate_booking_services: assignPenultimateBookingServices,
    month_birthday: assignMonthBirthDayTags,
    frequency_visit: assignFrequencyVisit,
    visits_in_one_year: assignVisitsInOneYear,
    visits_in_half_year: assignVisitsInHalfYear,
    visits_in_custom_period: assignVisitsInCustomPeriod,
    staffs: assignStaffTags,
  };
  return functionMap[tagType] || null;
};

/**
 * 最新の予約メニュータグのセット
 * @param {Record<string, any[]>} tags
 */
const assignLatestBookingServices = (tags: any) => {
  const bookingMenuTagData = DistributionGroupUtils.assignTagFormat(
    tags["latest_booking_services"].value,
    "latest_booking_services",
    null
  );
  set(latestBookingMenuTags, bookingMenuTagData);
};

/**
 * 前回施術メニュータグのセット
 * @param {Record<string, any[]>} tags
 */
const assignPenultimateBookingServices = (tags: any) => {
  const bookingMenuTagData = DistributionGroupUtils.assignTagFormat(
    tags["penultimate_booking_services"].value,
    "penultimate_booking_services",
    null
  );
  set(penultimateBookingMenuTags, bookingMenuTagData);
};

/**
 * 月別誕生日タグのセット
 * @param {Record<string, any[]>} tags
 */
const assignMonthBirthDayTags = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(tags["month_birthday"].value, "month_birthday", null);
  set(monthBirthDayTags, tagData);
};

/**
 * 来店頻度タグのセット
 * @param {Record<string, any[]>} tags
 */
const assignFrequencyVisit = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(tags["frequency_visit"].value, "frequency_visit", null);
  set(frequencyVisitTags, tagData);
};

/**
 * 来店回数タグのセット (1年間)
 * @param {Record<string, any[]>} tags
 */
const assignVisitsInOneYear = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(tags["visits_in_one_year"].value, "visits_in_one_year", null);
  set(visitsInOneYearTags, tagData);
};

/**
 * 来店回数タグのセット (半年間)
 * @param {Record<string, any[]>} tags
 */
const assignVisitsInHalfYear = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(
    tags["visits_in_half_year"].value,
    "visits_in_half_year",
    null
  );
  set(visitsInHalfYearTags, tagData);
};

/**
 * 来店回数タグのセット (カスタム期間)
 * @param {Record<string, any[]>} tags
 */
const assignVisitsInCustomPeriod = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(
    tags["visits_in_custom_period"].value,
    "visits_in_custom_period",
    null
  );
  set(visitsInCustomPeriodTags, tagData);
};

/**
 * 指名スタッフタグのセット
 * @param {Record<string, any[]>} tags
 */
const assignStaffTags = (tags: any) => {
  const tagData = DistributionGroupUtils.assignTagFormat(tags["staffs"].value, "staffs", null);
  set(staffTags, tagData);
};

/**
 * 顧客ステータスオプションを取得する
 * @async
 */
const loadCustomerStatuses = async () => {
  try {
    const params = { clinic_id: clinicId.value };
    const response = await DistributionGroupService.getCustomerStatuses(params);
    if (response.data.value?.customer_statuses) {
      set(customerStatusOptions, response.data.value.customer_statuses);
    }
  } catch (error) {
    console.error("顧客ステータスの取得に失敗しました:", error);
    // エラーメッセージを表示
    toast.add({
      severity: "error",
      summary: "エラー",
      detail: "顧客ステータスの取得に失敗しました。デフォルトの設定を使用します。",
      life: 5000,
    });
    // エラーの場合はデフォルトのオプションを使用
    set(customerStatusOptions, DefaultCustomerStatusOptions);
  }
};

/**
 * 自動タグや手動タグ一覧を取得・設定する
 * @async
 */
const loadTags = async () => {
  set(isLoading, true);

  // バックエンドで悩みカテゴリが自動追加されるため、1回のAPI呼び出しで十分
  const params = { clinic_id: clinicId.value, id: props.distributionGroupId, display_tags: displayTags };
  const response = await DistributionGroupService.getAllTags(params);

  // 悩みカテゴリのキーを動的に取得（表示用）
  const problemKeys = Object.keys(response.data.value.automatic_tags || {}).filter(key => key.startsWith("problem_"));
  set(dynamicProblemKeys, problemKeys);

  const automaticTags = response.data.value.automatic_tags;
  setAutomaticTags(automaticTags);
  setCustomerTags(response.data.value.tags);
  set(resultNumber, response.data.value.total_customers);
  set(totalCustomer, response.data.value.total_customers);

  set(isLoading, false);
};

/**
 * 手動タグをリスト化して格納する
 * @param {any[]} tags - APIから取得した手動タグ一覧
 */
const setCustomerTags = (tags: any[]) => {
  const allTagData = tags.map((tag: any) => ({
    value: tag.name,
    label: tag.name,
    type: tag.type || TagTypeEnum.manual,
    category_name: tag.category_name,
    position_number: tag.position_number,
  }));

  const filteredTags = allTagData.filter(tag => tag.type != TagTypeEnum.partner);
  const filteredPartnerTags = allTagData.filter(tag => tag.type == TagTypeEnum.partner);
  set(listTags, filteredTags);
  set(partnerTags, filteredPartnerTags);

  // 手動タグをカテゴリごとにグループ化
  const manualTags = filteredTags.filter(tag => tag.type === TagTypeEnum.manual);
  const groupedTags: Record<string, any[]> = {};

  manualTags.forEach(tag => {
    const categoryName = tag.category_name || "カテゴリー未選択";
    if (!groupedTags[categoryName]) {
      groupedTags[categoryName] = [];
    }
    groupedTags[categoryName].push(tag);
  });

  // カテゴリをソートして「カテゴリ未選択」を最後に表示
  const sortedGroupedTags: Record<string, any[]> = {};
  const categoryWithPosition: Array<{ name: string; position: number }> = [];

  Object.keys(groupedTags).forEach(categoryName => {
    if (categoryName === "カテゴリー未選択") {
      categoryWithPosition.push({ name: categoryName, position: 9999 });
    } else {
      const firstTag = groupedTags[categoryName][0];
      const position = firstTag?.position_number || 0;
      categoryWithPosition.push({ name: categoryName, position });
    }
  });

  // position_numberで昇順ソート
  categoryWithPosition.sort((a, b) => a.position - b.position);

  // ソートされた順序で結果を構築
  categoryWithPosition.forEach(({ name }) => {
    sortedGroupedTags[name] = groupedTags[name];
  });

  set(manualTagsByCategory, sortedGroupedTags);
};

/**
 * 選択されたdisplay_tagsを取得する
 * @returns {string[]} 選択されたタグの配列
 */
const getSelectedDisplayTags = (): string[] => {
  const selectedTags: string[] = [];

  // 各フィルターの選択状態をチェックして、選択されたタグのみを追加
  // ここでは例として、基本的なフィルターが選択されている場合の処理
  // 実際の実装では、各フィルターの選択状態に応じてタグを追加

  // 例: 性別フィルターが選択されている場合
  if (filterGender.value !== "all_gender") {
    selectedTags.push("gender");
  }

  // 例: 年齢フィルターが選択されている場合
  if (filterAgeType.value !== "template_age") {
    selectedTags.push("age");
  }

  // 例: 来店履歴フィルターが選択されている場合（実際に回数指定がある場合のみ）
  if (
    visitHistory.value !== "all_time" &&
    (customTotalVisitMin.value !== "no_min" ||
      customTotalVisitMax.value !== "no_max" ||
      customMonthlyAverageMin.value !== "no_min" ||
      customMonthlyAverageMax.value !== "no_max")
  ) {
    selectedTags.push("visit_history");
  }

  // 例: 利用金額フィルターが選択されている場合（実際に金額指定がある場合のみ）
  if (
    amountHistory.value !== "all_time" &&
    (totalAmountMinNoLimit.value === false ||
      totalAmountMaxNoLimit.value === false ||
      monthlyAverageAmountMinNoLimit.value === false ||
      monthlyAverageAmountMaxNoLimit.value === false ||
      averagePriceMinNoLimit.value === false ||
      averagePriceMaxNoLimit.value === false)
  ) {
    selectedTags.push("amount_history");
  }

  // 手動タグは自動タグとは別に処理するため、ここでは追加しない
  // 手動タグは別途@tagsパラメータとして送信される
  return selectedTags;
};

/**
 * 下限と上限の値の妥当性をチェックする
 * @param {string} min - 下限値
 * @param {string} max - 上限値
 * @returns {boolean} 妥当な場合はtrue、そうでない場合はfalse
 */
const validateMinMax = (min: string, max: string): boolean => {
  if (min === "no_min" || max === "no_max") return true;

  const minNum = parseInt(min);
  const maxNum = parseInt(max);

  if (isNaN(minNum) || isNaN(maxNum)) return true; // 数値以外の場合はスキップ

  return minNum <= maxNum;
};

/**
 * 総来店回数の下限変更時の処理
 * @param {any} event - 変更イベント
 */
const onTotalVisitMinChange = (event: any) => {
  const min = event.value;
  const max = get(customTotalVisitMax);

  if (min && max && min !== "no_min" && max !== "no_max" && !validateMinMax(min, max)) {
    // 下限 > 上限の場合は上限を下限以上に補正
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const correctedMax = Math.max(minNum, maxNum);
    set(customTotalVisitMax, correctedMax.toString());
  }

  // プルダウンで選択した値を適切な設定変数に保存
  updateVisitHistorySettings();
};

/**
 * 総来店回数の上限変更時の処理
 * @param {any} event - 変更イベント
 */
const onTotalVisitMaxChange = (event: any) => {
  const max = event.value;
  const min = get(customTotalVisitMin);

  if (min && max && min !== "no_min" && max !== "no_max" && !validateMinMax(min, max)) {
    // 下限 > 上限の場合は上限を下限以上に補正
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const correctedMax = Math.max(minNum, maxNum);
    set(customTotalVisitMax, correctedMax.toString());
  }

  // 上限が変更された場合、下限が上限を超えている場合は下限を調整
  if (max && max !== "no_max") {
    const maxNum = parseInt(max);
    if (!isNaN(maxNum) && min && min !== "no_min") {
      const minNum = parseInt(min);
      if (!isNaN(minNum) && minNum > maxNum) {
        set(customTotalVisitMin, maxNum.toString());
      }
    }
  }

  // プルダウンで選択した値を適切な設定変数に保存
  updateVisitHistorySettings();
};

/**
 * プルダウンで選択した値を適切な設定変数に保存する
 */
const updateVisitHistorySettings = () => {
  const min = get(customTotalVisitMin);
  const max = get(customTotalVisitMax);

  // 下限または上限のいずれかが有効な値の場合に設定を保存
  if (min && max && (min !== "no_min" || max !== "no_max")) {
    const setting = `${min}-${max}`;
    const currentVisitHistory = visitHistory.value;

    if (currentVisitHistory === "all_time") {
      set(allTimeVisitHistorySettings, [setting]);
    } else if (currentVisitHistory === "current_month") {
      set(currentMonthVisitHistorySettings, [setting]);
    } else if (currentVisitHistory === "three_months") {
      set(threeMonthsVisitHistorySettings, [setting]);
    } else if (currentVisitHistory === "one_year") {
      set(oneYearVisitHistorySettings, [setting]);
    } else if (currentVisitHistory === "half_year") {
      set(halfYearVisitHistorySettings, [setting]);
    } else if (currentVisitHistory === "custom_period") {
      set(customPeriodVisitHistorySettings, [setting]);
    }
  }
};

/**
 * 月平均来店回数の下限変更時の処理
 * @param {any} event - 変更イベント
 */
const onMonthlyAverageMinChange = (event: any) => {
  const min = event.value;
  const max = get(customMonthlyAverageMax);

  if (min && max && min !== "no_min" && max !== "no_max" && !validateMinMax(min, max)) {
    // 下限 > 上限の場合は上限を下限以上に補正
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const correctedMax = Math.max(minNum, maxNum);
    set(customMonthlyAverageMax, correctedMax.toString());
  }

  // プルダウンで選択した値を適切な設定変数に保存
  updateMonthlyAverageSettings();
};

/**
 * 月平均来店回数の上限変更時の処理
 * @param {any} event - 変更イベント
 */
const onMonthlyAverageMaxChange = (event: any) => {
  const max = event.value;
  const min = get(customMonthlyAverageMin);

  if (min && max && min !== "no_min" && max !== "no_max" && !validateMinMax(min, max)) {
    // 下限 > 上限の場合は上限を下限以上に補正
    const minNum = parseInt(min);
    const maxNum = parseInt(max);
    const correctedMax = Math.max(minNum, maxNum);
    set(customMonthlyAverageMax, correctedMax.toString());
  }

  // 上限が変更された場合、下限が上限を超えている場合は下限を調整
  if (max && max !== "no_max") {
    if (max === "less_1") {
      // 上限が「1回未満」の場合、下限も「1回未満」に調整
      if (min && min !== "no_min" && min !== "less_1") {
        set(customMonthlyAverageMin, "less_1");
      }
    } else {
      const maxNum = parseInt(max);
      if (!isNaN(maxNum) && min && min !== "no_min" && min !== "less_1") {
        const minNum = parseInt(min);
        if (!isNaN(minNum) && minNum > maxNum) {
          set(customMonthlyAverageMin, maxNum.toString());
        }
      }
    }
  }

  // プルダウンで選択した値を適切な設定変数に保存
  updateMonthlyAverageSettings();
};

/**
 * プルダウンで選択した月平均来店回数の値を適切な設定変数に保存する
 */
const updateMonthlyAverageSettings = () => {
  const min = get(customMonthlyAverageMin);
  const max = get(customMonthlyAverageMax);

  if (min && max) {
    const setting = `${min}-${max}`;
    const currentVisitHistory = visitHistory.value;

    if (currentVisitHistory === "all_time") {
      set(allTimeMonthlyAverageSettings, [setting]);
    } else if (currentVisitHistory === "current_month") {
      set(currentMonthMonthlyAverageSettings, [setting]);
    } else if (currentVisitHistory === "three_months") {
      set(threeMonthsMonthlyAverageSettings, [setting]);
    } else if (currentVisitHistory === "one_year") {
      set(oneYearMonthlyAverageSettings, [setting]);
    } else if (currentVisitHistory === "half_year") {
      set(halfYearMonthlyAverageSettings, [setting]);
    } else if (currentVisitHistory === "custom_period") {
      set(customPeriodMonthlyAverageSettings, [setting]);
    }
  }
};

/**
 * visit_historyの値をバックエンドのenumキーに変換する
 * @param value {string} フロントエンドの値
 * @returns {string} バックエンドのenumキー
 */
const convertVisitHistoryValue = (value: string): string => {
  const mapping: Record<string, string> = {
    all_time: "visit_all_time",
    current_month: "visit_current_month",
    three_months: "visit_three_months",
    half_year: "visit_half_year",
    one_year: "visit_one_year",
    custom_period: "visit_custom_period",
  };
  return mapping[value] || value;
};

/**
 * visit_historyの値をバックエンドのenumキーからフロントエンドの値に逆変換する
 * @param value {string} バックエンドのenumキー
 * @returns {string} フロントエンドの値
 */
const convertVisitHistoryValueBack = (value: string): string => {
  const mapping: Record<string, string> = {
    visit_all_time: "all_time",
    visit_current_month: "current_month",
    visit_three_months: "three_months",
    visit_half_year: "half_year",
    visit_one_year: "one_year",
    visit_custom_period: "custom_period",
  };
  return mapping[value] || value;
};

/**
 * amount_historyの値をバックエンドのenumキーに変換する
 * @param value {string} フロントエンドの値
 * @returns {string} バックエンドのenumキー
 */
const convertAmountHistoryValue = (value: string): string => {
  const mapping: Record<string, string> = {
    all_time: "amount_all_time",
    current_month: "amount_current_month",
    three_months: "amount_three_months",
    half_year: "amount_half_year",
    one_year: "amount_one_year",
    custom_period: "amount_custom_period",
  };
  return mapping[value] || value;
};

/**
 * amount_historyの値をバックエンドのenumキーからフロントエンドの値に逆変換する
 * @param value {string} バックエンドのenumキー
 * @returns {string} フロントエンドの値
 */
const convertAmountHistoryValueBack = (value: string): string => {
  const mapping: Record<string, string> = {
    amount_all_time: "all_time",
    amount_current_month: "current_month",
    amount_three_months: "three_months",
    amount_half_year: "half_year",
    amount_one_year: "one_year",
    amount_custom_period: "custom_period",
  };
  return mapping[value] || value;
};

/**
 * 現在のフォームからAPIに渡すパラメータを生成する
 * @returns {ApiFilterReq} 生成したフィルタパラメータ
 */
const getParams = (): any => {
  // 総来店回数設定の処理
  const min = get(customTotalVisitMin);
  const max = get(customTotalVisitMax);
  let historySetting: any[] = [];

  if (min && max && min !== "no_min" && max !== "no_max") {
    if (validateMinMax(min, max)) {
      historySetting = [`${min}-${max}`];
    } else {
      // 下限 > 上限の場合は上限を下限以上に補正
      const minNum = parseInt(min);
      const maxNum = parseInt(max);
      const correctedMax = Math.max(minNum, maxNum);
      historySetting = [`${min}-${correctedMax}`];
      // 補正された値をUIに反映
      set(customTotalVisitMax, correctedMax.toString());
    }
  } else {
    // プルダウンで選択された値を取得
    const currentVisitHistory = visitHistory.value;
    if (currentVisitHistory === "all_time") {
      historySetting = allTimeVisitHistorySettings.value;
    } else if (currentVisitHistory === "current_month") {
      historySetting = currentMonthVisitHistorySettings.value;
    } else if (currentVisitHistory === "three_months") {
      historySetting = threeMonthsVisitHistorySettings.value;
    } else if (currentVisitHistory === "one_year") {
      historySetting = oneYearVisitHistorySettings.value;
    } else if (currentVisitHistory === "half_year") {
      historySetting = halfYearVisitHistorySettings.value;
    } else if (currentVisitHistory === "custom_period") {
      historySetting = customPeriodVisitHistorySettings.value;
    }
  }

  // 月平均来店回数設定の処理
  const monthlyMin = get(customMonthlyAverageMin);
  const monthlyMax = get(customMonthlyAverageMax);
  let monthlyAverageSetting: any[] = [];

  if (monthlyMin && monthlyMax) {
    if (validateMinMax(monthlyMin, monthlyMax)) {
      monthlyAverageSetting = [`${monthlyMin}-${monthlyMax}`];
    } else {
      // 下限 > 上限の場合は上限を下限以上に補正
      const minNum = parseInt(monthlyMin);
      const maxNum = parseInt(monthlyMax);
      const correctedMax = Math.max(minNum, maxNum);
      monthlyAverageSetting = [`${monthlyMin}-${correctedMax}`];
      // 補正された値をUIに反映
      set(customMonthlyAverageMax, correctedMax.toString());
    }
  } else {
    // プルダウンで選択された値を取得
    const currentVisitHistory = visitHistory.value;
    if (currentVisitHistory === "all_time") {
      monthlyAverageSetting = allTimeMonthlyAverageSettings.value;
    } else if (currentVisitHistory === "current_month") {
      monthlyAverageSetting = currentMonthMonthlyAverageSettings.value;
    } else if (currentVisitHistory === "three_months") {
      monthlyAverageSetting = threeMonthsMonthlyAverageSettings.value;
    } else if (currentVisitHistory === "one_year") {
      monthlyAverageSetting = oneYearMonthlyAverageSettings.value;
    } else if (currentVisitHistory === "half_year") {
      monthlyAverageSetting = halfYearMonthlyAverageSettings.value;
    } else if (currentVisitHistory === "custom_period") {
      monthlyAverageSetting = customPeriodMonthlyAverageSettings.value;
    }
  }

  const params = {
    clinic_id: clinicId.value,
    id: props.distributionGroupId,

    // 個別フィルター判定
    ...(filterGender.value !== "all_gender" ? { gender: filterGender.value } : {}),
    ...(filterAgeType.value !== "template_age" ? { age_type: filterAgeType.value } : {}),
    ...(filterTimeType.value !== "template_period" ? { period_type: filterTimeType.value } : {}),
    ...(bookingStatuses.value.length > 0 &&
    !bookingStatuses.value.includes("all") &&
    !bookingStatuses.value.includes("full")
      ? { booking_statuses: bookingStatuses.value }
      : {}),
    ...(customerStatuses.value.length > 0 && !customerStatuses.value.includes("all")
      ? { customer_statuses: customerStatuses.value }
      : {}),

    // 来店履歴フィルター（期間がall_time以外かつ、どれか一つでも回数指定がある場合のみ送信）
    ...(visitHistory.value !== "all_time" &&
    (customTotalVisitMin.value !== "no_min" ||
      customTotalVisitMax.value !== "no_max" ||
      customMonthlyAverageMin.value !== "no_min" ||
      customMonthlyAverageMax.value !== "no_max")
      ? { visit_history: convertVisitHistoryValue(visitHistory.value) }
      : {}),
    ...(visitHistory.value !== "all_time" &&
    (customTotalVisitMin.value !== "no_min" ||
      customTotalVisitMax.value !== "no_max" ||
      customMonthlyAverageMin.value !== "no_min" ||
      customMonthlyAverageMax.value !== "no_max")
      ? { visit_history_settings: historySetting }
      : {}),

    // 月平均来店回数フィルター（期間がall_time以外かつ、どれか一つでも回数指定がある場合のみ送信）
    ...(visitHistory.value !== "all_time" &&
    (customTotalVisitMin.value !== "no_min" ||
      customTotalVisitMax.value !== "no_max" ||
      customMonthlyAverageMin.value !== "no_min" ||
      customMonthlyAverageMax.value !== "no_max")
      ? { monthly_average_settings: monthlyAverageSetting }
      : {}),

    // 利用金額フィルター（期間設定は、どれか一つでも金額指定がある場合のみ送信）
    ...(amountHistory.value !== "all_time" &&
    (totalAmountMinNoLimit.value === false ||
      totalAmountMaxNoLimit.value === false ||
      monthlyAverageAmountMinNoLimit.value === false ||
      monthlyAverageAmountMaxNoLimit.value === false ||
      averagePriceMinNoLimit.value === false ||
      averagePriceMaxNoLimit.value === false)
      ? { amount_history: convertAmountHistoryValue(amountHistory.value) }
      : {}),
    // 総利用金額フィルター（どちらか一方でも金額指定がある場合は送信）
    ...(totalAmountMinNoLimit.value === false || totalAmountMaxNoLimit.value === false
      ? {
          ...(totalAmountMinNoLimit.value
            ? { total_amount_min: "no_min" }
            : { total_amount_min: totalAmountMinValue.value }),
          ...(totalAmountMaxNoLimit.value
            ? { total_amount_max: "no_max" }
            : { total_amount_max: totalAmountMaxValue.value }),
        }
      : {}),
    // 月平均利用金額フィルター（どちらか一方でも金額指定がある場合は送信）
    ...(monthlyAverageAmountMinNoLimit.value === false || monthlyAverageAmountMaxNoLimit.value === false
      ? {
          ...(monthlyAverageAmountMinNoLimit.value
            ? { monthly_average_amount_min: "no_min" }
            : { monthly_average_amount_min: monthlyAverageAmountMinValue.value }),
          ...(monthlyAverageAmountMaxNoLimit.value
            ? { monthly_average_amount_max: "no_max" }
            : { monthly_average_amount_max: monthlyAverageAmountMaxValue.value }),
        }
      : {}),
    // 平均単価フィルター（どちらか一方でも金額指定がある場合は送信）
    ...(averagePriceMinNoLimit.value === false || averagePriceMaxNoLimit.value === false
      ? {
          ...(averagePriceMinNoLimit.value
            ? { average_price_min: "no_min" }
            : { average_price_min: averagePriceMinValue.value }),
          ...(averagePriceMaxNoLimit.value
            ? { average_price_max: "no_max" }
            : { average_price_max: averagePriceMaxValue.value }),
        }
      : {}),

    // カスタム来店回数設定
    ...(customTotalVisitMin.value !== "no_min" || customTotalVisitMax.value !== "no_max"
      ? {
          custom_total_visit_min: customTotalVisitMin.value,
          custom_total_visit_max: customTotalVisitMax.value,
        }
      : {}),

    // カスタム月平均来店回数設定
    ...(customMonthlyAverageMin.value !== "no_min" || customMonthlyAverageMax.value !== "no_max"
      ? {
          custom_monthly_average_min: customMonthlyAverageMin.value,
          custom_monthly_average_max: customMonthlyAverageMax.value,
        }
      : {}),

    // 選択されたフィルターに基づいてdisplay_tagsを送信
    ...(getSelectedDisplayTags().length > 0 ? { display_tags: getSelectedDisplayTags() } : {}),

    // 基本パラメータ（常に送信）
    // 年齢フィルターのデバッグ
    ...(filterAgeType.value === "range_age"
      ? { age: [`${filterAgeStart.value}-${filterAgeEnd.value}`] }
      : { age: filterAges.value }),
    // 期間フィルターのデバッグ
    ...(filterTimeType.value === "range_period"
      ? {
          period: `${moment(filterTimeStart.value).format("YYYY/MM/DD")}-${moment(filterTimeEnd.value).format(
            "YYYY/MM/DD"
          )}`,
        }
      : { period: `${filterTime.value}` }),
    // フィルタータイプの送信（バックエンドで必要）
    age_type: filterAgeType.value,
    period_type: filterTimeType.value,
    tags: filterTags.value,
  };

  // 任意期間が選択されている場合、開始日と終了日を追加
  if (visitHistory.value === "custom_period" && customPeriodStart.value && customPeriodEnd.value) {
    // タイムゾーンを考慮した日付変換
    const startDate = new Date(customPeriodStart.value);
    const endDate = new Date(customPeriodEnd.value);
    (params as any).custom_period_start = startDate.toLocaleDateString("en-CA"); // YYYY-MM-DD形式
    (params as any).custom_period_end = endDate.toLocaleDateString("en-CA"); // YYYY-MM-DD形式
  }

  // 利用金額設定の任意期間が選択されている場合、開始日と終了日を追加
  if (amountHistory.value === "custom_period" && amountCustomPeriodStart.value && amountCustomPeriodEnd.value) {
    // タイムゾーンを考慮した日付変換
    const startDate = new Date(amountCustomPeriodStart.value);
    const endDate = new Date(amountCustomPeriodEnd.value);
    (params as any).amount_start_date = startDate.toLocaleDateString("en-CA"); // YYYY-MM-DD形式
    (params as any).amount_end_date = endDate.toLocaleDateString("en-CA"); // YYYY-MM-DD形式
  }

  return params;
};

/**
 * 「ターゲット数を確認」ボタン押下時の処理
 * APIにフィルタ設定を渡して該当ユーザー数を取得し、ダイアログに表示する
 */
const onGetFilterResult = async () => {
  try {
    let params = getParams();
    if (JSON.stringify(params) == JSON.stringify(props.targetInformation)) {
      (params as any)["rejected_customer_codes"] = props.rejectedCustomerCodes;
    }

    const response = await DistributionGroupService.getFilterResult(params);
    set(resultNumber, response.data.value.result);

    getResultDialog.value = true;
  } catch (error) {
    // エラーメッセージは既にgetParams内で表示されているため、ここでは何もしない
    console.error("フィルター実行エラー:", error);
  }
};

/**
 * DistributionGroupの更新用パラメータを取得
 * @returns {any} DistributionGroupの更新に必要なパラメータのみ
 */
const getDistributionGroupParams = (): any => {
  const params = getParams();

  // DistributionGroupモデルに存在する属性のみを抽出
  // display_tagsなど、DistributionGroupモデルに存在しない属性は除外
  const { display_tags, ...distributionGroupParams } = params;

  return {
    status: "draft",
    ...distributionGroupParams,
  };
};

/**
 * 利用金額設定のバリデーション
 * @returns {object} バリデーション結果
 */
const validateAmountSettings = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // 総利用金額のバリデーション
  if (!totalAmountMinNoLimit.value && !totalAmountMinValue.value) {
    errors.push("総利用金額の下限を入力してください");
  }
  if (!totalAmountMaxNoLimit.value && !totalAmountMaxValue.value) {
    errors.push("総利用金額の上限を入力してください");
  }

  // 月平均利用金額のバリデーション
  if (!monthlyAverageAmountMinNoLimit.value && !monthlyAverageAmountMinValue.value) {
    errors.push("月平均利用金額の下限を入力してください");
  }
  if (!monthlyAverageAmountMaxNoLimit.value && !monthlyAverageAmountMaxValue.value) {
    errors.push("月平均利用金額の上限を入力してください");
  }

  // 平均単価のバリデーション
  if (!averagePriceMinNoLimit.value && !averagePriceMinValue.value) {
    errors.push("平均単価の下限を入力してください");
  }
  if (!averagePriceMaxNoLimit.value && !averagePriceMaxValue.value) {
    errors.push("平均単価の上限を入力してください");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * 「下書き保存する」ボタン押下時の処理
 * フィルタ情報をAPIに送信してdraft状態として保存する
 * @param {boolean} previousStep - trueならば「前設定へ戻る」時の保存として扱う
 */
const onSaveDraft = async (previousStep: any) => {
  // バリデーションチェック
  const validation = validateAmountSettings();
  if (!validation.isValid) {
    validation.errors.forEach(error => {
      notityErrorMsg(toast, error);
    });
    return;
  }

  let params = getParams();
  let distributionGroupParams = getDistributionGroupParams();

  const clinicParam = { clinic_id: clinicId.value };

  const [error] = await handleError(
    DistributionGroupService.updateTargetSettings(
      props.distributionGroupId,
      clinicParam,
      distributionGroupParams as ApiFilterReq
    )
  );

  if (error) {
    notityErrorMsg(toast, "下書き保存に失敗しました");
    return;
  }

  if (previousStep) {
    onPreviousStep();
  } else {
    set(hasPermissionRedirect, true);
    set(safeDraftDialog, true);
  }
};

/**
 * Promiseを扱う際のエラー処理を簡単にするためのヘルパー
 * @param {Promise} promise - 実行するPromise
 * @returns {Array} [error, data] いずれかが格納される
 */
const handleError = (promise: any) => {
  return promise.then((data: any) => [undefined, data]).catch((error: any) => [error, undefined]);
};

/**
 * 「TOPに戻る」ボタン押下時の処理
 * 配信グループリスト画面へ遷移
 */
const goToGroupLists = () => {
  set(hasPermissionRedirect, true);
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME as any);
};

/**
 * 「前設定へ戻る」実行時の処理
 * ステップを前に戻すためのemitを実行
 */
const onPreviousStep = async () => {
  warningReturnVisible.value = false;
  emits("changeTargetViewType", "setting");
  emits("resourcesFn", 1);
};

/**
 * 「保存してページを移動する」ダイアログでの「下書き保存」ボタン押下時の処理
 * 保存成功後に次の画面に遷移する
 */
const saveDraftWhenRedirect = async () => {
  let distributionGroupParams = getDistributionGroupParams();

  const clinicParam = { clinic_id: clinicId.value };

  const [error] = await handleError(
    DistributionGroupService.updateTargetSettings(
      props.distributionGroupId,
      clinicParam,
      distributionGroupParams as ApiFilterReq
    )
  );

  if (error) {
    console.error("Save draft error:", error);
    notityErrorMsg(toast, "下書き保存に失敗しました");
  } else {
    set(hasPermissionRedirect, true);
    if (get(nextRoute)) {
      router.push(nextRoute.value as any);
    }
  }
};

/**
 * 「破棄する」ボタン押下時の処理
 * 新規作成モードの場合は作成途中の配信グループを削除し、画面遷移する
 */
const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    if (get(nextRoute)) {
      router.push(nextRoute.value as any);
    }
  } catch (error) {
    // 開発環境でのみ詳細ログを出力
    if (process.env.NODE_ENV === "development") {
      console.error("[配信グループ削除] エラーが発生しました:", {
        error: error,
        distributionGroupId: props.distributionGroupId,
        isEdit: props.isEdit,
      });
    }

    // ユーザー向けエラーメッセージ
    notityErrorMsg(toast, "配信グループの削除に失敗しました。もう一度お試しください。");
  }
};

/**
 * ルート離脱前フック
 * 下書き保存せずに遷移しようとした場合は警告ダイアログを表示
 */
onBeforeRouteLeave((to, _from, next) => {
  if (props.finalSetting) {
    next();
    return;
  }

  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

/**
 * 年齢指定が「年代タグ」のときにSelectButtonが変更された際の処理
 * 「すべて」以外を選択したら「すべて」を削除する
 * @param {any} event - イベントオブジェクト
 */
const onChangeAgeTemplate = (event: any) => {
  if (event.event.target.textContent != "すべて") {
    const newFilterAges = filterAges.value.filter(template => template != "すべて");
    set(filterAges, newFilterAges);
  } else {
    set(filterAges, ["すべて"]);
  }
};

/**
 * 来店ステータスSelectButtonの変更ハンドラ
 * 「すべて」以外を選択したら「すべて」を削除する
 * @param {any} event - イベントオブジェクト
 */
const onChangeBookingStatus = (event: any) => {
  if (event.event.target.textContent != "すべて") {
    const newBookingStatuses = bookingStatuses.value.filter(template => template != "full");
    set(bookingStatuses, newBookingStatuses);
  } else {
    set(bookingStatuses, ["full"]);
  }
};

/**
 * 顧客ステータスSelectButtonの変更ハンドラ
 * 「すべて」以外を選択したら「すべて」を削除する
 * @param {any} event - イベントオブジェクト
 */
const onChangeCustomerStatus = (event: any) => {
  if (event.event.target.textContent != "すべて") {
    const newCustomerStatuses = customerStatuses.value.filter(template => template != "all");
    set(customerStatuses, newCustomerStatuses);
  } else {
    set(customerStatuses, ["all"]);
  }
};

/**
 * ブラウザがリロードされる前に実行されるイベント
 * 下書き保存されないままページ遷移(リロード)が行われる場合は警告を出したり、新規時は配信グループを削除するなどの処理が可能
 * @param {BeforeUnloadEvent} event
 */
const handleBeforeUnload = (event: any) => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

/**
 * フォームの初期値を再セットする
 * - ページマウント時、および「ユーザ選定を見る」ボタン押下時
 */
const setInitialForm = () => {
  initialForm.value = {
    gender: filterGender.value,
    ages: filterAges.value,
    ageStart: filterAgeStart.value,
    ageEnd: filterAgeEnd.value,
    ageType: filterAgeType.value,
    time: filterTime.value,
    timeType: filterTimeType.value,
    timeStart: filterTimeStart.value,
    timeEnd: filterTimeEnd.value,
    bookingStatuses: bookingStatuses.value,
    customerStatuses: customerStatuses.value,
    visitHistory: visitHistory.value,
    allTimeVisitHistorySettings: allTimeVisitHistorySettings.value,
    currentMonthVisitHistorySettings: currentMonthVisitHistorySettings.value,
    threeMonthsVisitHistorySettings: threeMonthsVisitHistorySettings.value,
    filterTags: filterTags.value,
  };
};

/**
 * フォームの現在値が初期値から変化しているかどうかを判定するフラグ
 * - 変更があればtrue、なければfalse
 */
const isFormChanged = computed<boolean>(() => {
  if (filterGender.value !== initialForm.value.gender) return true;
  if (filterAges.value !== initialForm.value.ages) return true;
  if (filterAgeStart.value !== initialForm.value.ageStart) return true;
  if (filterAgeEnd.value !== initialForm.value.ageEnd) return true;
  if (filterAgeType.value !== initialForm.value.ageType) return true;
  if (filterTime.value !== initialForm.value.time) return true;
  if (filterTimeType.value !== initialForm.value.timeType) return true;
  if (filterTimeStart.value !== initialForm.value.timeStart) return true;
  if (filterTimeEnd.value !== initialForm.value.timeEnd) return true;
  if (bookingStatuses.value !== initialForm.value.bookingStatuses) return true;
  if (customerStatuses.value !== initialForm.value.customerStatuses) return true;
  if (visitHistory.value !== initialForm.value.visitHistory) return true;
  if (allTimeVisitHistorySettings.value !== initialForm.value.allTimeVisitHistorySettings) return true;
  if (currentMonthVisitHistorySettings.value !== initialForm.value.currentMonthVisitHistorySettings) return true;
  if (threeMonthsVisitHistorySettings.value !== initialForm.value.threeMonthsVisitHistorySettings) return true;
  if (filterTags.value !== initialForm.value.filterTags) return true;
  return false;
});

/** コンポーネントが破棄される前のフック */
onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

/** コンポーネントがマウントされたときのフック */
onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  const stepSetting = document.getElementById("step-setting");
  if (stepSetting) {
    stepSetting.scrollIntoView();
  }
});

/**
 * コンポーネントがマウントされる前のフック
 * clinicIdを取得し、タグ一覧をロードする
 * props.targetInformationが存在する場合は初期値を設定
 */
onBeforeMount(async () => {
  const currentClinicId = await store.dispatch("authClient/getClinicIdCookie");
  set(clinicId, currentClinicId);
  await loadCustomerStatuses();
  loadTags();

  // カスタム入力の初期化
  if (props.targetInformation) {
    // 既存の設定がある場合は復元
    const visitSettings = props.targetInformation.visit_history_settings || [];
    const monthlySettings = props.targetInformation.monthly_average_settings || [];

    // カスタム値の復元
    const customVisitSetting = visitSettings.find(
      (setting: string) =>
        setting.includes("-") && !["1-1", "2-3", "4-5", "6-10", "11-20", "21-30", "31-"].includes(setting)
    );
    if (customVisitSetting) {
      const range = customVisitSetting.split("-");
      set(customTotalVisitMin, range[0]);
      set(customTotalVisitMax, range[1]);
    }

    const customMonthlySetting = monthlySettings.find(
      (setting: string) => setting.includes("-") && !["less_1", "1", "2", "3", "4+"].includes(setting)
    );
    if (customMonthlySetting) {
      const range = customMonthlySetting.split("-");
      set(customMonthlyAverageMin, range[0]);
      set(customMonthlyAverageMax, range[1]);
    }
  }

  if (!props.targetInformation) {
    setInitialForm();
    return;
  }

  // age_typeがundefinedの場合は、ageの値から判断
  if (
    props.targetInformation.age_type == "template_age" ||
    (props.targetInformation.age_type === undefined &&
      props.targetInformation.age &&
      props.targetInformation.age.length > 0 &&
      (props.targetInformation.age[0] === "すべて" ||
        (props.targetInformation.age[0]?.includes("-") && props.targetInformation.age[0]?.endsWith("NaN")) ||
        props.targetInformation.age[0]?.endsWith("歳") ||
        props.targetInformation.age[0]?.endsWith("以上") ||
        props.targetInformation.age[0]?.includes("歳以上")))
  ) {
    set(filterAgeType, "template_age");
    set(filterAges, props.targetInformation.age);
  } else {
    const ageRange = props.targetInformation.age[0].split("-");
    set(filterAgeType, "range_age");
    set(filterAgeStart, parseInt(ageRange[0]));
    set(filterAgeEnd, parseInt(ageRange[1]));
  }

  // period_typeがundefinedの場合は、periodの値から判断
  if (
    props.targetInformation.period_type == "template_period" ||
    (props.targetInformation.period_type === undefined &&
      (props.targetInformation.period === 0 ||
        props.targetInformation.period === "0" ||
        props.targetInformation.period === 7 ||
        props.targetInformation.period === "7" ||
        props.targetInformation.period === 14 ||
        props.targetInformation.period === "14" ||
        props.targetInformation.period === 30 ||
        props.targetInformation.period === "30" ||
        props.targetInformation.period === 90 ||
        props.targetInformation.period === "90" ||
        props.targetInformation.period === 180 ||
        props.targetInformation.period === "180" ||
        props.targetInformation.period === 365 ||
        props.targetInformation.period === "365"))
  ) {
    set(filterTimeType, "template_period");
    set(filterTime, parseInt(props.targetInformation.period));
  } else {
    const timeRange = props.targetInformation.period.split("-");
    set(filterTimeType, "range_period");
    set(filterTimeStart, timeRange[0]);
    set(filterTimeEnd, timeRange[1]);
  }

  // フィルター値の明示的な設定
  if (props.targetInformation.gender && props.targetInformation.gender !== "all_gender") {
    set(filterGender, props.targetInformation.gender);
  } else {
    set(filterGender, "all_gender");
  }

  if (props.targetInformation.booking_statuses && props.targetInformation.booking_statuses.length > 0) {
    set(bookingStatuses, props.targetInformation.booking_statuses);
  } else {
    set(bookingStatuses, ["full"]);
  }

  if (props.targetInformation.customer_statuses && props.targetInformation.customer_statuses.length > 0) {
    set(customerStatuses, props.targetInformation.customer_statuses);
  } else {
    set(customerStatuses, ["all"]);
  }

  // タグの復元
  if (props.targetInformation.tags) {
    if (Array.isArray(props.targetInformation.tags)) {
      // tagsが配列の場合（選択されたタグのリスト）
      set(filterTags, props.targetInformation.tags);
    } else if (typeof props.targetInformation.tags === "object") {
      // tagsがハッシュの場合、selected_tagsキーをチェック
      if (props.targetInformation.tags.selected_tags && Array.isArray(props.targetInformation.tags.selected_tags)) {
        // selected_tagsキーが存在する場合、その配列を使用
        set(filterTags, props.targetInformation.tags.selected_tags);
      } else {
        // selected_tagsキーがない場合は空配列
        set(filterTags, []);
      }
    }
  } else {
    set(filterTags, []);
  }

  // 利用金額設定の復元（tagsカラムまたはamount_settingsから）
  let amountSettings: any = {};
  if (
    props.targetInformation.tags &&
    typeof props.targetInformation.tags === "object" &&
    !Array.isArray(props.targetInformation.tags)
  ) {
    // tagsがハッシュの場合
    if (props.targetInformation.tags.amount_settings) {
      // amount_settingsキーが存在する場合
      amountSettings = props.targetInformation.tags.amount_settings;
    } else {
      // 直接利用金額設定が含まれている場合
      amountSettings = props.targetInformation.tags;
    }
  } else if (props.targetInformation.amount_settings) {
    // amount_settingsが別途保存されている場合
    amountSettings = props.targetInformation.amount_settings;
  }

  if (Object.keys(amountSettings).length > 0) {
    // 総利用金額設定の復元
    if (amountSettings.total_amount_min) {
      if (amountSettings.total_amount_min === "no_min") {
        totalAmountMinNoLimit.value = true;
        totalAmountMinValue.value = undefined;
      } else {
        totalAmountMinNoLimit.value = false;
        totalAmountMinValue.value = parseInt(amountSettings.total_amount_min);
      }
    }

    if (amountSettings.total_amount_max) {
      if (amountSettings.total_amount_max === "no_max") {
        totalAmountMaxNoLimit.value = true;
        totalAmountMaxValue.value = undefined;
      } else {
        totalAmountMaxNoLimit.value = false;
        totalAmountMaxValue.value = parseInt(amountSettings.total_amount_max);
      }
    }

    // 月平均利用金額設定の復元
    if (amountSettings.monthly_average_amount_min) {
      if (amountSettings.monthly_average_amount_min === "no_min") {
        monthlyAverageAmountMinNoLimit.value = true;
        monthlyAverageAmountMinValue.value = undefined;
      } else {
        monthlyAverageAmountMinNoLimit.value = false;
        monthlyAverageAmountMinValue.value = parseInt(amountSettings.monthly_average_amount_min);
      }
    }

    if (amountSettings.monthly_average_amount_max) {
      if (amountSettings.monthly_average_amount_max === "no_max") {
        monthlyAverageAmountMaxNoLimit.value = true;
        monthlyAverageAmountMaxValue.value = undefined;
      } else {
        monthlyAverageAmountMaxNoLimit.value = false;
        monthlyAverageAmountMaxValue.value = parseInt(amountSettings.monthly_average_amount_max);
      }
    }

    // 平均単価設定の復元
    if (amountSettings.average_price_min) {
      if (amountSettings.average_price_min === "no_min") {
        averagePriceMinNoLimit.value = true;
        averagePriceMinValue.value = undefined;
      } else {
        averagePriceMinNoLimit.value = false;
        averagePriceMinValue.value = parseInt(amountSettings.average_price_min);
      }
    }

    if (amountSettings.average_price_max) {
      if (amountSettings.average_price_max === "no_max") {
        averagePriceMaxNoLimit.value = true;
        averagePriceMaxValue.value = undefined;
      } else {
        averagePriceMaxNoLimit.value = false;
        averagePriceMaxValue.value = parseInt(amountSettings.average_price_max);
      }
    }

    // 利用金額期間設定の復元
    if (amountSettings.amount_start_date) {
      set(amountCustomPeriodStart, new Date(amountSettings.amount_start_date));
    }
    if (amountSettings.amount_end_date) {
      set(amountCustomPeriodEnd, new Date(amountSettings.amount_end_date));
    }
  }

  // 来店履歴設定の復元
  if (props.targetInformation.visit_history) {
    const convertedValue = convertVisitHistoryValueBack(props.targetInformation.visit_history);
    set(visitHistory, convertedValue);
  }

  // 来店履歴の詳細設定を復元
  if (props.targetInformation.visit_history_settings) {
    const currentVisitHistory = convertVisitHistoryValueBack(props.targetInformation.visit_history);
    if (currentVisitHistory === "all_time") {
      set(allTimeVisitHistorySettings, props.targetInformation.visit_history_settings);
    } else if (currentVisitHistory === "current_month") {
      set(currentMonthVisitHistorySettings, props.targetInformation.visit_history_settings);
    } else if (currentVisitHistory === "three_months") {
      set(threeMonthsVisitHistorySettings, props.targetInformation.visit_history_settings);
    } else if (currentVisitHistory === "half_year") {
      set(halfYearVisitHistorySettings, props.targetInformation.visit_history_settings);
    } else if (currentVisitHistory === "one_year") {
      set(oneYearVisitHistorySettings, props.targetInformation.visit_history_settings);
    } else if (currentVisitHistory === "custom_period") {
      set(customPeriodVisitHistorySettings, props.targetInformation.visit_history_settings);
    }
  }

  // 月平均来店回数の詳細設定を復元（amount_settingsから）
  if (amountSettings.monthly_average_settings) {
    const currentVisitHistory = convertVisitHistoryValueBack(props.targetInformation.visit_history);
    if (currentVisitHistory === "all_time") {
      set(allTimeMonthlyAverageSettings, amountSettings.monthly_average_settings);
    } else if (currentVisitHistory === "current_month") {
      set(currentMonthMonthlyAverageSettings, amountSettings.monthly_average_settings);
    } else if (currentVisitHistory === "three_months") {
      set(threeMonthsMonthlyAverageSettings, amountSettings.monthly_average_settings);
    } else if (currentVisitHistory === "half_year") {
      set(halfYearMonthlyAverageSettings, amountSettings.monthly_average_settings);
    } else if (currentVisitHistory === "one_year") {
      set(oneYearMonthlyAverageSettings, amountSettings.monthly_average_settings);
    } else if (currentVisitHistory === "custom_period") {
      set(customPeriodMonthlyAverageSettings, amountSettings.monthly_average_settings);
    }
  } else if (props.targetInformation.monthly_average_settings) {
    // フォールバック: 直接monthly_average_settingsが保存されている場合
    const currentVisitHistory = convertVisitHistoryValueBack(props.targetInformation.visit_history);
    if (currentVisitHistory === "all_time") {
      set(allTimeMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    } else if (currentVisitHistory === "current_month") {
      set(currentMonthMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    } else if (currentVisitHistory === "three_months") {
      set(threeMonthsMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    } else if (currentVisitHistory === "half_year") {
      set(halfYearMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    } else if (currentVisitHistory === "one_year") {
      set(oneYearMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    } else if (currentVisitHistory === "custom_period") {
      set(customPeriodMonthlyAverageSettings, props.targetInformation.monthly_average_settings);
    }
  }

  // 利用金額履歴設定の復元
  if (amountSettings.amount_history) {
    set(amountHistory, convertAmountHistoryValueBack(amountSettings.amount_history));
  } else if (props.targetInformation.amount_history) {
    set(amountHistory, convertAmountHistoryValueBack(props.targetInformation.amount_history));
  }

  // 総利用金額設定の復元
  if (props.targetInformation.total_amount_min) {
    set(totalAmountMin, props.targetInformation.total_amount_min);
    if (props.targetInformation.total_amount_min === "no_min") {
      totalAmountMinNoLimit.value = true;
      totalAmountMinValue.value = undefined;
    } else {
      totalAmountMinNoLimit.value = false;
      totalAmountMinValue.value = parseInt(props.targetInformation.total_amount_min);
    }
  }

  if (props.targetInformation.total_amount_max) {
    set(totalAmountMax, props.targetInformation.total_amount_max);
    if (props.targetInformation.total_amount_max === "no_max") {
      totalAmountMaxNoLimit.value = true;
      totalAmountMaxValue.value = undefined;
    } else {
      totalAmountMaxNoLimit.value = false;
      totalAmountMaxValue.value = parseInt(props.targetInformation.total_amount_max);
    }
  }

  // 月平均利用金額設定の復元
  if (props.targetInformation.monthly_average_amount_min) {
    set(monthlyAverageAmountMin, props.targetInformation.monthly_average_amount_min);
    if (props.targetInformation.monthly_average_amount_min === "no_min") {
      monthlyAverageAmountMinNoLimit.value = true;
      monthlyAverageAmountMinValue.value = undefined;
    } else {
      monthlyAverageAmountMinNoLimit.value = false;
      monthlyAverageAmountMinValue.value = parseInt(props.targetInformation.monthly_average_amount_min);
    }
  }

  if (props.targetInformation.monthly_average_amount_max) {
    set(monthlyAverageAmountMax, props.targetInformation.monthly_average_amount_max);
    if (props.targetInformation.monthly_average_amount_max === "no_max") {
      monthlyAverageAmountMaxNoLimit.value = true;
      monthlyAverageAmountMaxValue.value = undefined;
    } else {
      monthlyAverageAmountMaxNoLimit.value = false;
      monthlyAverageAmountMaxValue.value = parseInt(props.targetInformation.monthly_average_amount_max);
    }
  }

  // 平均単価設定の復元
  if (props.targetInformation.average_price_min) {
    if (props.targetInformation.average_price_min === "no_min") {
      averagePriceMinNoLimit.value = true;
      averagePriceMinValue.value = undefined;
    } else {
      averagePriceMinNoLimit.value = false;
      averagePriceMinValue.value = parseInt(props.targetInformation.average_price_min);
    }
  }

  if (props.targetInformation.average_price_max) {
    if (props.targetInformation.average_price_max === "no_max") {
      averagePriceMaxNoLimit.value = true;
      averagePriceMaxValue.value = undefined;
    } else {
      averagePriceMaxNoLimit.value = false;
      averagePriceMaxValue.value = parseInt(props.targetInformation.average_price_max);
    }
  }

  // 月平均来店回数設定の復元
  if (props.targetInformation.monthly_average_settings) {
    const monthlySettings = props.targetInformation.monthly_average_settings || [];
    const currentAmountHistory = amountHistory.value;

    if (currentAmountHistory === "all_time") {
      set(allTimeMonthlyAverageSettings, monthlySettings);
    } else if (currentAmountHistory === "current_month") {
      set(currentMonthMonthlyAverageSettings, monthlySettings);
    } else if (currentAmountHistory === "three_months") {
      set(threeMonthsMonthlyAverageSettings, monthlySettings);
    } else if (currentAmountHistory === "one_year") {
      set(oneYearMonthlyAverageSettings, monthlySettings);
    } else if (currentAmountHistory === "half_year") {
      set(halfYearMonthlyAverageSettings, monthlySettings);
    } else if (currentAmountHistory === "custom_period") {
      set(customPeriodMonthlyAverageSettings, monthlySettings);
    }

    // カスタム値の復元
    const customMonthlySetting = monthlySettings.find(
      (setting: string) => setting.includes("-") && !["less_1", "1", "2", "3", "4+"].includes(setting)
    );
    if (customMonthlySetting) {
      const range = customMonthlySetting.split("-");
      set(customMonthlyAverageMin, range[0]);
      set(customMonthlyAverageMax, range[1]);
    }
  }

  // amountSettingsからカスタム月平均来店回数設定を復元
  if (amountSettings.custom_monthly_average_min) {
    set(customMonthlyAverageMin, amountSettings.custom_monthly_average_min);
  }
  if (amountSettings.custom_monthly_average_max) {
    set(customMonthlyAverageMax, amountSettings.custom_monthly_average_max);
  }

  // 来店履歴設定の復元
  if (props.targetInformation.visit_history) {
    const convertedValue = convertVisitHistoryValueBack(props.targetInformation.visit_history);
    set(visitHistory, convertedValue);

    // 期間別の設定を復元
    if (convertedValue === "all_time") {
      set(allTimeVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    } else if (convertedValue === "current_month") {
      set(currentMonthVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    } else if (convertedValue === "three_months") {
      set(threeMonthsVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    } else if (convertedValue === "one_year") {
      set(oneYearVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    } else if (convertedValue === "half_year") {
      set(halfYearVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    } else if (convertedValue === "custom_period") {
      set(customPeriodVisitHistorySettings, props.targetInformation.visit_history_settings || []);
    }

    // 任意期間の開始日・終了日を復元
    if (convertedValue === "custom_period") {
      if (amountSettings.custom_period_start) {
        set(customPeriodStart, new Date(amountSettings.custom_period_start));
      } else if (props.targetInformation.custom_period_start) {
        set(customPeriodStart, new Date(props.targetInformation.custom_period_start));
      }
      if (amountSettings.custom_period_end) {
        set(customPeriodEnd, new Date(amountSettings.custom_period_end));
      } else if (props.targetInformation.custom_period_end) {
        set(customPeriodEnd, new Date(props.targetInformation.custom_period_end));
      }
    }
  }

  // 利用金額設定の任意期間の開始日・終了日を復元
  if (amountHistory.value === "custom_period") {
    if (amountSettings.amount_start_date) {
      set(amountCustomPeriodStart, new Date(amountSettings.amount_start_date));
    } else if (props.targetInformation.amount_start_date) {
      set(amountCustomPeriodStart, new Date(props.targetInformation.amount_start_date));
    }
    if (amountSettings.amount_end_date) {
      set(amountCustomPeriodEnd, new Date(amountSettings.amount_end_date));
    } else if (props.targetInformation.amount_end_date) {
      set(amountCustomPeriodEnd, new Date(props.targetInformation.amount_end_date));
    }
  }

  // 復元処理の最後に初期フォームを設定
  setInitialForm();
});

// 新しい自由入力形式の値が変更されたときに既存の変数に同期
watch([totalAmountMinNoLimit, totalAmountMinValue, totalAmountMaxNoLimit, totalAmountMaxValue], () => {
  syncAmountValues();
  // 値が変更された時に範囲チェックを実行
  setTimeout(() => {
    checkTotalAmountRange();
  }, 0);
});

watch(
  [
    monthlyAverageAmountMinNoLimit,
    monthlyAverageAmountMinValue,
    monthlyAverageAmountMaxNoLimit,
    monthlyAverageAmountMaxValue,
  ],
  () => {
    syncAmountValues();
    // 値が変更された時に範囲チェックを実行
    setTimeout(() => {
      checkMonthlyAverageRange();
    }, 0);
  }
);

watch([averagePriceMinNoLimit, averagePriceMinValue, averagePriceMaxNoLimit, averagePriceMaxValue], () => {
  syncAmountValues();
  // 値が変更された時に範囲チェックを実行
  setTimeout(() => {
    checkAveragePriceRange();
  }, 0);
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "mb-5 mt-3 border-round-lg" }, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["form-filter-content basic-filter", { 'pointer-events-none': props.finalSetting }])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: filterGender.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterGender).value = $event)),
                    inputId: "gender-1",
                    name: "gender",
                    value: "male"
                  }, null, 8, ["modelValue"]),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: filterGender.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterGender).value = $event)),
                    inputId: "gender-2",
                    name: "gender",
                    value: "female"
                  }, null, 8, ["modelValue"]),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: filterGender.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterGender).value = $event)),
                    inputId: "gender-3",
                    name: "gender",
                    value: "unknown"
                  }, null, 8, ["modelValue"]),
                  _hoisted_11
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(RadioButton), {
                    modelValue: filterGender.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterGender).value = $event)),
                    inputId: "gender-4",
                    name: "gender",
                    value: "all_gender"
                  }, null, 8, ["modelValue"]),
                  _hoisted_13
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "filter-age-template",
                    name: "filter-age-type",
                    modelValue: filterAgeType.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterAgeType).value = $event)),
                    value: "template_age"
                  }, null, 8, ["modelValue"]),
                  _hoisted_18
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: filterAges.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterAges).value = $event)),
                    options: _unref(AgeFilterOptions),
                    optionLabel: "label",
                    optionValue: "label",
                    multiple: "",
                    "aria-labelledby": "multiple",
                    name: "filter_age",
                    disabled: filterAgeType.value !== 'template_age',
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (onChangeAgeTemplate($event)))
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "filter-age-range",
                    name: "filter-age-type",
                    modelValue: filterAgeType.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterAgeType).value = $event)),
                    value: "range_age"
                  }, null, 8, ["modelValue"]),
                  _hoisted_22
                ]),
                _createVNode(_unref(Dropdown), {
                  modelValue: filterAgeStart.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filterAgeStart).value = $event)),
                  options: _unref(ageRangeOptions),
                  optionValue: "value",
                  optionLabel: "label",
                  class: "mr-5 font-normal filter-calendar",
                  inputProps: { class: 'font-light text-black20 text-sm' },
                  placeholder: _unref(PLACEHOLDER_SELECT),
                  disabled: filterAgeType.value !== 'range_age'
                }, null, 8, ["modelValue", "options", "placeholder", "disabled"]),
                _createVNode(_unref(Dropdown), {
                  modelValue: filterAgeEnd.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filterAgeEnd).value = $event)),
                  options: _unref(ageRangeOptions),
                  optionValue: "value",
                  optionLabel: "label",
                  class: "mr-2 font-normal filter-calendar",
                  inputProps: { class: 'font-light text-black20 text-sm' },
                  placeholder: _unref(PLACEHOLDER_SELECT),
                  disabled: filterAgeType.value !== 'range_age'
                }, null, 8, ["modelValue", "options", "placeholder", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: bookingStatuses.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((bookingStatuses).value = $event)),
                    options: _unref(DistributionGroupBookingStatusOptions),
                    optionLabel: "name",
                    optionValue: "value",
                    multiple: "",
                    "aria-labelledby": "multiple",
                    name: "filter-time",
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (onChangeBookingStatus($event)))
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: customerStatuses.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customerStatuses).value = $event)),
                    options: customerStatusOptions.value,
                    optionLabel: "name",
                    optionValue: "value",
                    multiple: "",
                    "aria-labelledby": "multiple",
                    name: "filter-customer-status",
                    onChange: _cache[13] || (_cache[13] = ($event: any) => (onChangeCustomerStatus($event)))
                  }, null, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "filter-visited-time-template",
                    name: "filter-visited-time-type",
                    modelValue: filterTimeType.value,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((filterTimeType).value = $event)),
                    value: "template_period"
                  }, null, 8, ["modelValue"]),
                  _hoisted_35
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_unref(SelectButton), {
                    modelValue: filterTime.value,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filterTime).value = $event)),
                    options: _unref(FilterTimeOptions),
                    optionLabel: "label",
                    optionValue: "value",
                    "aria-labelledby": "multiple",
                    name: "filter-time",
                    disabled: filterTimeType.value !== 'template_period',
                    unselectable: false
                  }, null, 8, ["modelValue", "options", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(RadioButton), {
                    inputId: "filter-visited-time-range",
                    name: "filter-visited-time-type",
                    modelValue: filterTimeType.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((filterTimeType).value = $event)),
                    value: "range_period"
                  }, null, 8, ["modelValue"]),
                  _hoisted_39
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_unref(Calendar), {
                    modelValue: filterTimeStart.value,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((filterTimeStart).value = $event)),
                    class: "justify-content-end filter-calendar",
                    showIcon: "",
                    dateFormat: "yy/mm/dd",
                    disabled: filterTimeType.value !== 'range_period'
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_42,
                  _createVNode(_unref(Calendar), {
                    modelValue: filterTimeEnd.value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((filterTimeEnd).value = $event)),
                    class: "justify-content-end filter-calendar mt-1",
                    showIcon: "",
                    dateFormat: "yy/mm/dd",
                    disabled: filterTimeType.value !== 'range_period'
                  }, null, 8, ["modelValue", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-all-time",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((visitHistory).value = $event)),
                      value: "all_time",
                      onChange: _cache[20] || (_cache[20] = ($event: any) => (onChangeVisitHistory('all_time')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_49
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-current-month",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((visitHistory).value = $event)),
                      value: "current_month",
                      onChange: _cache[22] || (_cache[22] = ($event: any) => (onChangeVisitHistory('current_month')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_51
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-three-months",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((visitHistory).value = $event)),
                      value: "three_months",
                      onChange: _cache[24] || (_cache[24] = ($event: any) => (onChangeVisitHistory('three_months')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_53
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-half-year",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((visitHistory).value = $event)),
                      value: "half_year",
                      onChange: _cache[26] || (_cache[26] = ($event: any) => (onChangeVisitHistory('half_year')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_55
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-one-year",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((visitHistory).value = $event)),
                      value: "one_year",
                      onChange: _cache[28] || (_cache[28] = ($event: any) => (onChangeVisitHistory('one_year')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_57
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-history-visit-custom-period",
                      name: "history-visit-period",
                      modelValue: visitHistory.value,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((visitHistory).value = $event)),
                      value: "custom_period",
                      onChange: _cache[30] || (_cache[30] = ($event: any) => (onChangeVisitHistory('custom_period')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_59
                  ])
                ])
              ]),
              (visitHistory.value === 'custom_period')
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      (showCustomPeriodDateError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_66, [
                        _hoisted_67,
                        _createVNode(_unref(Calendar), {
                          modelValue: customPeriodStart.value,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((customPeriodStart).value = $event)),
                          showIcon: true,
                          dateFormat: "yy-mm-dd",
                          maxDate: new Date(),
                          disabled: visitHistory.value !== 'custom_period' || props.finalSetting,
                          class: "w-full",
                          onDateSelect: checkCustomPeriodDateRange
                        }, null, 8, ["modelValue", "maxDate", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createVNode(_unref(Calendar), {
                          modelValue: customPeriodEnd.value,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((customPeriodEnd).value = $event)),
                          showIcon: true,
                          dateFormat: "yy-mm-dd",
                          maxDate: new Date(),
                          disabled: visitHistory.value !== 'custom_period' || props.finalSetting,
                          class: "w-full",
                          onDateSelect: checkCustomPeriodDateRange
                        }, null, 8, ["modelValue", "maxDate", "disabled"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_unref(Dropdown), {
                        modelValue: customTotalVisitMin.value,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((customTotalVisitMin).value = $event)),
                        options: getTotalVisitMinOptions(),
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "下限を選択",
                        disabled: props.finalSetting,
                        class: "w-8rem",
                        onChange: onTotalVisitMinChange
                      }, null, 8, ["modelValue", "options", "disabled"]),
                      _hoisted_76,
                      _createVNode(_unref(Dropdown), {
                        modelValue: customTotalVisitMax.value,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((customTotalVisitMax).value = $event)),
                        options: getTotalVisitMaxOptions(),
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "上限を選択",
                        disabled: props.finalSetting,
                        class: "w-8rem",
                        onChange: onTotalVisitMaxChange
                      }, null, 8, ["modelValue", "options", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _createVNode(_unref(Dropdown), {
                        modelValue: customMonthlyAverageMin.value,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((customMonthlyAverageMin).value = $event)),
                        options: getMonthlyAverageMinOptions(),
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "下限を選択",
                        disabled: props.finalSetting,
                        class: "w-8rem",
                        onChange: onMonthlyAverageMinChange
                      }, null, 8, ["modelValue", "options", "disabled"]),
                      _hoisted_80,
                      _createVNode(_unref(Dropdown), {
                        modelValue: customMonthlyAverageMax.value,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((customMonthlyAverageMax).value = $event)),
                        options: getMonthlyAverageMaxOptions(),
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "上限を選択",
                        disabled: props.finalSetting,
                        class: "w-8rem",
                        onChange: onMonthlyAverageMaxChange
                      }, null, 8, ["modelValue", "options", "disabled"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    (showAveragePriceError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_87, _hoisted_90))
                      : _createCommentVNode("", true),
                    (showAveragePriceRangeError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                          _hoisted_92,
                          _createElementVNode("span", _hoisted_93, _toDisplayString(averagePriceRangeErrorMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: averagePriceMinNoLimit.value,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((averagePriceMinNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_97
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: averagePriceMinValue.value,
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((averagePriceMinValue).value = $event)),
                          disabled: averagePriceMinNoLimit.value || props.finalSetting,
                          placeholder: "下限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onPaste: handlePaste,
                          onKeypress: preventNonNumericInputAveragePrice,
                          onCompositionstart: handleCompositionStartAveragePrice,
                          onCompositionupdate: handleCompositionUpdateAveragePrice,
                          onCompositionend: handleCompositionEndAveragePrice,
                          onFocus: handleFocusAveragePrice
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _hoisted_98,
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: averagePriceMaxNoLimit.value,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((averagePriceMaxNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_101
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: averagePriceMaxValue.value,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((averagePriceMaxValue).value = $event)),
                          disabled: averagePriceMaxNoLimit.value || props.finalSetting,
                          placeholder: "上限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onPaste: handlePaste,
                          onKeypress: preventNonNumericInputAveragePriceMax,
                          onCompositionstart: handleCompositionStartAveragePrice,
                          onCompositionupdate: handleCompositionUpdateAveragePrice,
                          onCompositionend: handleCompositionEndAveragePrice,
                          onFocus: handleFocusAveragePriceMax
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_102, [
                _hoisted_103,
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-all-time",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((amountHistory).value = $event)),
                      value: "all_time",
                      onChange: _cache[42] || (_cache[42] = ($event: any) => (onChangeAmountHistory('all_time')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_106
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-current-month",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((amountHistory).value = $event)),
                      value: "current_month",
                      onChange: _cache[44] || (_cache[44] = ($event: any) => (onChangeAmountHistory('current_month')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_108
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-three-months",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((amountHistory).value = $event)),
                      value: "three_months",
                      onChange: _cache[46] || (_cache[46] = ($event: any) => (onChangeAmountHistory('three_months')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_110
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-half-year",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((amountHistory).value = $event)),
                      value: "half_year",
                      onChange: _cache[48] || (_cache[48] = ($event: any) => (onChangeAmountHistory('half_year')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_112
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-one-year",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((amountHistory).value = $event)),
                      value: "one_year",
                      onChange: _cache[50] || (_cache[50] = ($event: any) => (onChangeAmountHistory('one_year')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_114
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createVNode(_unref(RadioButton), {
                      inputId: "filter-amount-custom-period",
                      name: "amount-period",
                      modelValue: amountHistory.value,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((amountHistory).value = $event)),
                      value: "custom_period",
                      onChange: _cache[52] || (_cache[52] = ($event: any) => (onChangeAmountHistory('custom_period')))
                    }, null, 8, ["modelValue"]),
                    _hoisted_116
                  ])
                ])
              ]),
              (amountHistory.value === 'custom_period')
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, [
                      (showAmountCustomPeriodDateError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, _hoisted_122))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_123, [
                        _hoisted_124,
                        _createVNode(_unref(Calendar), {
                          modelValue: amountCustomPeriodStart.value,
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((amountCustomPeriodStart).value = $event)),
                          showIcon: true,
                          dateFormat: "yy-mm-dd",
                          maxDate: new Date(),
                          disabled: amountHistory.value !== 'custom_period' || props.finalSetting,
                          class: "w-full",
                          onDateSelect: checkAmountCustomPeriodDateRange
                        }, null, 8, ["modelValue", "maxDate", "disabled"])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _createVNode(_unref(Calendar), {
                          modelValue: amountCustomPeriodEnd.value,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((amountCustomPeriodEnd).value = $event)),
                          showIcon: true,
                          dateFormat: "yy-mm-dd",
                          maxDate: new Date(),
                          disabled: amountHistory.value !== 'custom_period' || props.finalSetting,
                          class: "w-full",
                          onDateSelect: checkAmountCustomPeriodDateRange
                        }, null, 8, ["modelValue", "maxDate", "disabled"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    (showTotalAmountError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, _hoisted_135))
                      : _createCommentVNode("", true),
                    (showTotalAmountRangeError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                          _hoisted_137,
                          _createElementVNode("span", _hoisted_138, _toDisplayString(totalAmountRangeErrorMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: totalAmountMinNoLimit.value,
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((totalAmountMinNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting,
                            onChange: onTotalAmountMinNoLimitChange
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_142
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: totalAmountMinValue.value,
                          "onUpdate:modelValue": [
                            _cache[56] || (_cache[56] = ($event: any) => ((totalAmountMinValue).value = $event)),
                            handleNumericInputTotal
                          ],
                          disabled: totalAmountMinNoLimit.value || props.finalSetting,
                          placeholder: "下限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onPaste: handlePaste,
                          onKeypress: preventNonNumericInputTotal,
                          onCompositionstart: handleCompositionStartTotal,
                          onCompositionupdate: handleCompositionUpdateTotal,
                          onCompositionend: handleCompositionEndTotal,
                          onMounted: handleInputNumberMountedTotal,
                          onFocus: handleFocusTotal,
                          onBlur: handleBlurTotal
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _hoisted_143,
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("div", _hoisted_145, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: totalAmountMaxNoLimit.value,
                            "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((totalAmountMaxNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting,
                            onChange: onTotalAmountMaxNoLimitChange
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_146
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: totalAmountMaxValue.value,
                          "onUpdate:modelValue": [
                            _cache[58] || (_cache[58] = ($event: any) => ((totalAmountMaxValue).value = $event)),
                            handleNumericInputTotalMax
                          ],
                          disabled: totalAmountMaxNoLimit.value || props.finalSetting,
                          placeholder: "上限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onPaste: handlePaste,
                          onKeypress: preventNonNumericInputTotalMax,
                          onCompositionstart: handleCompositionStartTotal,
                          onCompositionupdate: handleCompositionUpdateTotal,
                          onCompositionend: handleCompositionEndTotal,
                          onMounted: handleInputNumberMountedTotal,
                          onFocus: handleFocusTotalMax,
                          onBlur: handleBlurTotalMax
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_147, [
                    _hoisted_148,
                    (showMonthlyAverageError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_149, _hoisted_152))
                      : _createCommentVNode("", true),
                    (showMonthlyAverageRangeError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                          _hoisted_154,
                          _createElementVNode("span", _hoisted_155, _toDisplayString(monthlyAverageRangeErrorMessage.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("div", _hoisted_158, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: monthlyAverageAmountMinNoLimit.value,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((monthlyAverageAmountMinNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting,
                            onChange: onMonthlyAverageAmountMinNoLimitChange
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_159
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: monthlyAverageAmountMinValue.value,
                          "onUpdate:modelValue": [
                            _cache[60] || (_cache[60] = ($event: any) => ((monthlyAverageAmountMinValue).value = $event)),
                            handleNumericInputMonthly
                          ],
                          disabled: monthlyAverageAmountMinNoLimit.value || props.finalSetting,
                          placeholder: "下限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onKeypress: preventNonNumericInputMonthly,
                          onPaste: handlePaste,
                          onCompositionstart: handleCompositionStartMonthly,
                          onCompositionupdate: handleCompositionUpdateMonthly,
                          onCompositionend: handleCompositionEndMonthly,
                          onMounted: handleInputNumberMountedMonthly,
                          onFocus: handleFocusMonthly,
                          onBlur: handleBlurMonthly
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _hoisted_160,
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _createVNode(_unref(Checkbox), {
                            modelValue: monthlyAverageAmountMaxNoLimit.value,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((monthlyAverageAmountMaxNoLimit).value = $event)),
                            binary: true,
                            disabled: props.finalSetting,
                            onChange: onMonthlyAverageAmountMaxNoLimitChange
                          }, null, 8, ["modelValue", "disabled"]),
                          _hoisted_163
                        ]),
                        _createVNode(_unref(InputNumber), {
                          modelValue: monthlyAverageAmountMaxValue.value,
                          "onUpdate:modelValue": [
                            _cache[62] || (_cache[62] = ($event: any) => ((monthlyAverageAmountMaxValue).value = $event)),
                            handleNumericInputMonthlyMax
                          ],
                          disabled: monthlyAverageAmountMaxNoLimit.value || props.finalSetting,
                          placeholder: "上限金額を入力",
                          min: 0,
                          max: 999999999,
                          mode: "currency",
                          currency: "JPY",
                          locale: "ja-JP",
                          class: "amount-input",
                          onPaste: handlePaste,
                          onKeypress: preventNonNumericInputMonthlyMax,
                          onCompositionstart: handleCompositionStartMonthly,
                          onCompositionupdate: handleCompositionUpdateMonthly,
                          onCompositionend: handleCompositionEndMonthly,
                          onMounted: handleInputNumberMountedMonthly,
                          onFocus: handleFocusMonthlyMax,
                          onBlur: handleBlurMonthlyMax
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex justify-content-center", { 'pointer-events-none': props.finalSetting }])
          }, _hoisted_165, 2),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_166, _hoisted_168))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["form-filter-content pt-2 tag-filter", { 'pointer-events-none': props.finalSetting }])
              }, _hoisted_171, 2))
            : _createCommentVNode("", true),
          _createVNode(FilterDistributionGroupCustomer, {
            label: "予約時の情報",
            filterTags: filterTags.value,
            "onUpdate:filterTags": updateFilterTags,
            options: latestBookingMenuTags.value,
            isLoading: isLoading.value,
            finalSetting: props.finalSetting,
            tagClass: "tag-orange"
          }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]),
          _createVNode(FilterDistributionGroupCustomer, {
            label: "前回施術メニュー",
            filterTags: filterTags.value,
            "onUpdate:filterTags": updateFilterTags,
            options: penultimateBookingMenuTags.value,
            isLoading: isLoading.value,
            finalSetting: props.finalSetting,
            tagClass: "tag-orange"
          }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]),
          _createVNode(FilterDistributionGroupCustomer, {
            label: "誕生月",
            filterTags: filterTags.value,
            "onUpdate:filterTags": updateFilterTags,
            options: monthBirthDayTags.value,
            isLoading: isLoading.value,
            finalSetting: props.finalSetting,
            tagClass: "tag-orange"
          }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(problemTags.value).slice(0, 3), (problemTagData, _key) => {
            return (_openBlock(), _createBlock(FilterDistributionGroupCustomer, {
              key: _key,
              label: problemTagData[1].displayName,
              filterTags: filterTags.value,
              "onUpdate:filterTags": updateFilterTags,
              options: problemTagData[1].tags,
              isLoading: isLoading.value,
              finalSetting: props.finalSetting,
              tagClass: "tag-orange"
            }, null, 8, ["label", "filterTags", "options", "isLoading", "finalSetting"]))
          }), 128)),
          _createVNode(FilterDistributionGroupCustomer, {
            label: "指名スタッフ",
            filterTags: filterTags.value,
            "onUpdate:filterTags": updateFilterTags,
            options: staffTags.value,
            isLoading: isLoading.value,
            finalSetting: props.finalSetting,
            tagClass: "tag-orange"
          }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]),
          _createVNode(FilterDistributionGroupCustomer, {
            label: "来店周期",
            filterTags: filterTags.value,
            "onUpdate:filterTags": updateFilterTags,
            options: frequencyVisitTags.value,
            isLoading: isLoading.value,
            finalSetting: props.finalSetting,
            tagClass: "tag-orange"
          }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]),
          (!isLoading.value && Object.keys(manualTagsByCategory.value).length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(["form-filter-content pt-2 tag-filter", { 'pointer-events-none': props.finalSetting }])
              }, _hoisted_173, 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(manualTagsByCategory.value), (categoryName, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (manualTagsByCategory.value[categoryName] && manualTagsByCategory.value[categoryName].length > 0)
                ? (_openBlock(), _createBlock(FilterDistributionGroupCustomer, {
                    key: 0,
                    label: categoryName,
                    filterTags: filterTags.value,
                    "onUpdate:filterTags": updateFilterTags,
                    options: manualTagsByCategory.value[categoryName],
                    isLoading: isLoading.value,
                    finalSetting: props.finalSetting,
                    tagClass: "tag-blue"
                  }, null, 8, ["label", "filterTags", "options", "isLoading", "finalSetting"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Ripicle)
            ? (_openBlock(), _createBlock(FilterDistributionGroupCustomer, {
                key: 3,
                label: "RIPICLEタグ",
                filterTags: filterTags.value,
                "onUpdate:filterTags": updateFilterTags,
                options: partnerTags.value,
                isLoading: isLoading.value,
                finalSetting: props.finalSetting,
                tagClass: ""
              }, null, 8, ["filterTags", "options", "isLoading", "finalSetting"]))
            : _createCommentVNode("", true),
          (props.finalSetting == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                _createVNode(_component_Button, {
                  class: "col-2 temp-save-btn ml-5",
                  label: "下書き保存する",
                  onClick: _cache[63] || (_cache[63] = ($event: any) => (onSaveDraft(false)))
                }),
                _createVNode(_component_Button, {
                  class: "col-2 check-result-btn ml-5",
                  label: "ターゲット数を確認",
                  onClick: onGetFilterResult
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (props.finalSetting == true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5",
              label: "編集画面に戻る",
              onClick: backFromFinalStep
            })
          ]))
        : _createCommentVNode("", true),
      (props.finalSetting == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
            _createVNode(_component_Button, {
              class: "col-2 black-btn ml-5",
              label: "前設定へ戻る",
              onClick: onCheckSaveDraft
            }),
            _createVNode(_component_Button, {
              class: "col-2 check-result-btn ml-5",
              label: "選定ユーザーを見る",
              onClick: onSaveTargetCustomers
            }),
            _createVNode(_component_Button, {
              class: "col-2 create-btn ml-5 justify-content-center",
              onClick: onNextStep
            }, {
              default: _withCtx(() => [
                (nextStepLoading.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_177))
                  : _createCommentVNode("", true),
                _createTextVNode("配信設定へ進む ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Dialog), {
      visible: safeDraftDialog.value,
      "onUpdate:visible": _cache[65] || (_cache[65] = ($event: any) => ((safeDraftDialog).value = $event)),
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_178
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_179, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5",
            label: "TOPに戻る",
            onClick: goToGroupLists
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5",
            label: "作成を続ける",
            onClick: _cache[64] || (_cache[64] = ($event: any) => (safeDraftDialog.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[67] || (_cache[67] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_180
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_181, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: saveDraftWhenRedirect
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[66] || (_cache[66] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: getResultDialog.value,
      "onUpdate:visible": _cache[69] || (_cache[69] = ($event: any) => ((getResultDialog).value = $event)),
      modal: "",
      style: { width: '400px' },
      class: "mx-5 border-0",
      draggable: false,
      "show-header": false
    }, {
      default: _withCtx(() => [
        _hoisted_182,
        (resultNumber.value == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_183, "ターゲットがいません!"))
          : (resultNumber.value < 10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_184, "ターゲットが少なすぎます!"))
            : (_openBlock(), _createElementBlock("div", _hoisted_185, "十分なユーザー数を確保できております。")),
        (resultNumber.value == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
              _createVNode(_unref(CircleProgressBar), {
                value: resultNumber.value,
                max: totalCustomer.value,
                class: "zero-bar"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_187, [
                    _createElementVNode("div", _hoisted_188, _toDisplayString(resultNumber.value), 1),
                    _hoisted_189
                  ])
                ]),
                _: 1
              }, 8, ["value", "max"])
            ]))
          : (resultNumber.value < 10)
            ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                _createVNode(_unref(CircleProgressBar), {
                  value: resultNumber.value,
                  max: totalCustomer.value,
                  colorUnfilled: "#ff3399"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_191, [
                      _createElementVNode("div", _hoisted_192, _toDisplayString(resultNumber.value), 1),
                      _hoisted_193
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "max"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_194, [
                _createVNode(_unref(CircleProgressBar), {
                  value: resultNumber.value,
                  max: totalCustomer.value,
                  colorUnfilled: "#ffab12",
                  colorFilled: "#ffab12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_195, [
                      _createElementVNode("div", _hoisted_196, _toDisplayString(resultNumber.value), 1),
                      _hoisted_197
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "max"])
              ])),
        _createElementVNode("div", _hoisted_198, "登録友だち総数 " + _toDisplayString(totalCustomer.value) + "人", 1),
        _createElementVNode("div", _hoisted_199, [
          _createVNode(_component_Button, {
            label: "作成を続ける",
            class: "create-btn",
            onClick: _cache[68] || (_cache[68] = ($event: any) => (getResultDialog.value = false))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: warningReturnVisible.value,
      "onUpdate:visible": _cache[72] || (_cache[72] = ($event: any) => ((warningReturnVisible).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_200
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_201, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5",
            label: "下書き保存",
            onClick: _cache[70] || (_cache[70] = ($event: any) => (onSaveDraft(true)))
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5",
            label: "戻る",
            onClick: _cache[71] || (_cache[71] = ($event: any) => (warningReturnVisible.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn",
            label: "破棄する",
            onClick: onPreviousStep
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})